<style>
.h-5 {
  padding: 25px;
  height: 500px !important;
  overflow-y: auto;
}

.fade-enter-active, .fade-leave-active {
  transition: .2s all;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all .2s ease;
}

.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.slide-leave-active, .slide-enter-active {
  transition: .2s;
}

.slide-enter {
  transform: translate(100%, 0);
}

.slide-leave-to {
  transform: translate(-100%, 0);
}

.set-selected-condition {
  color: #f7a219;
}

.select-box-danger {
  border-color: #f0362d !important;
  box-shadow: 0 0 4px #ff9f4d;
}

.test-save-btn {
  border-radius: 30px;
  font-weight: 600;
  font-size: 13px;
}

.ls-none {
  text-align: center;
}

.dynamic-top-to {
  top: 100%;
}

.OldRecordDivIsOpen {
  display: block;
}

.schedule-modal-btn {
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  border-radius: 30px;
  font-weight: 600;
  font-size: 13px;
}

.automation-modal-header {
  border-bottom: 0;
  padding-bottom: 15px;
}

.automation-modal-header .automation-modal-title {
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  font-size: 18px;
  font-weight: 600;
}

.automation-schedule-form {
  padding: 0 20px;
}

.automation-schedule-form-container label {
  display: block;
  font-size: 14px;
  font-weight: 500;
}

.automation-schedule-form-container label sup {
  color: #f0362d;
  font-size: 16px;
  top: 0px;
  left: 3px;
  font-weight: 600;
}

.automation-schedule-form-container .automation-schedule-input {
  width: 100%;
  padding: 5px 10px;
  border-radius: 3px;
  border: 1px solid #bdbaba;
  margin-bottom: 25px;
}

.auto-schedule-day {
  width: 49%;
  display: inline-block;
  margin-right: 2%;
  border: 1px solid #bdbaba;
  padding: 6px 40px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  float: left;
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 30px;
  position: relative;
}

.auto-schedule-month {
  width: 49%;
  display: inline-block;
  border: 1px solid #bdbaba;
  padding: 6px 40px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  float: right;
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 30px;
  position: relative;
}

.addCheck {
  background-color: aliceblue;
}

.auto-schedule-select-days {
  float: left;
  width: 49%;
  margin-right: 2%;
  margin-bottom: 21px;
}

.auto-schedule-select-days select {
  background: #fff;
  padding: 6.5px;
  font-size: 14px;
  border-radius: 5px;
  width: 100%;
  border: 1px solid #bdbaba;
}

.auto-schedule-select-time {
  float: right;
  width: 49%;
  margin-bottom: 79px;
}

.schedule-time-picker {
  width: 100% !important;
  display: block !important;
}

.time-picker input.display-time {
  width: 100% !important;
  border-radius: 5px !important;
  font-size: 15px !important;
  padding: 17px 10px !important;
}

.auto-schedule-select-date-start {
  width: 49%;
  float: left;
  margin-right: 2%;
}

.auto-schedule-select-date-start input {
  border: 1px solid #bdbaba;
}

.auto-schedule-select-date-end {
  width: 49%;
  float: left;
}

.automation-modal-footer {
  padding-top: 25px;
  padding-bottom: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #ccc;
}

.automated-modal-body {
  padding-bottom: 40px;
}

.schedule-save {
  background: #4a8dee;
  padding: 5px 50px;
  margin-right: 15px;
  color: #fff;
  font-weight: 600;
  text-align: center;
  transition: 0.3s all;
}

.schedule-save:hover {
  background: #2f73d6;
}

.schedule-cancel {
  background: #fff;
  border: 1px solid #ccc;
  padding: 6px 40px;
  transition: 0.3s all;
}

.schedule-cancel:hover {
  background: #f5f5f5;
}

.field-input {
  height: 38px !important;
  min-height: 37px !important;
}

.is-invalid {
  border-color: #dc3545 !important;
}

.alert-danger {
  display: none;
}

.error-text {
  color: #ff0018 !important;
  font-size: 0.7rem !important;
}

.custom-cron-multi-select {
  list-style: none;
  height: 85px;
  overflow: auto;
  border: 1px solid #bdbaba;
  border-radius: 5px;
  font-size: 14px;
  padding: 4px 6px 6px 10px;
  margin-bottom: 0;
}

.custom-cron-multi-select li {
  cursor: pointer;
  padding-left: 5px;
}

.custom-cron-multi-select .selected {
  background-color: #f4a93f;
}

.btn-block {
  display: block !important;
}

.isGroup {
  position: relative;
  margin-top: 40px !important;
  margin-bottom: 15px;
}

.ck-editor__editable_inline {
  max-height: 265px !important;
  height: 255px !important;
}

.isGroup:before {
  content: '';
  position: absolute;
  border: 1px dashed #8897a3;
  top: -10px;
  bottom: -20px;
  width: 20px;
  border-right: 0;
  border-radius: 4px 0 0 4px;
  left: -21px;
}

.remove-query {
  position: absolute;
  top: -19px;
  left: 5px;
}

.remove-query:hover {
  color: red;
  cursor: pointer;
}

.custom-mt-5 {
  margin-top: 5px;
}

.adv-div {
  margin-top: 10px;
}

.advance-con-btn {
  background: none;
  border: none;
  color: #4ba0f8;
  font-size: 11px;
  font-weight: 600;
  margin-left: 10px;
}

.advance-con-btn:hover {
  text-decoration: underline;
  outline: none;
}

.advance-con-btn:focus {
  outline: none;
}

.add-contidion-btn {
  color: green;
  font-size: 11px;
  padding: 2px;
}

.dotted-border {
  border: 1px dashed;
  padding: 5px;
}

.ml-45 {
  margin-left: 45px;
}

.group-condition {
  position: absolute;
  display: inline-block;
  left: -77px;
  right: 0;
  top: -15px;
}

.task-container {
  margin-top: 50px;
}

.b-dropdown .dropdown-menu:focus {
  outline: none !important;
}

/* Preloader */
.automation_loader_container {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100vh;
}

.automation_loader {
  position: fixed;
  top: 50% !important;
  left: 100% !important;
  transform: translate(-50%, -50%);
  margin: 0 0 2em;
  height: 100px;
  width: 100%;
  text-align: center;
  padding: 1em;
  margin: 0 auto;
  display: inline-block;
  vertical-align: top;
}

.automation_loader .automation_loader_object {
  position: absolute;
  width: 20px;
  height: 20px;
  background: #262626;
  animation: animate 4s infinite forwards ease-in-out;
}

.automation_loader .automation_loader_object:nth-child(1) {
  background: #258CD5;
  left: -24px;
  top: -24px;
  animation-delay: 0.5s;
}

.automation_loader .automation_loader_object:nth-child(2) {
  background: #47cf73;
  left: 0px;
  top: -24px;
  animation-delay: 1s;
}

.automation_loader .automation_loader_object:nth-child(4) {
  background: #258CD5;
  left: -24px;
  top: 0px;
  animation-delay: 1.5s;
}

.automation_loader .automation_loader_object:nth-child(3) {
  background: #47cf73;
  left: 0px;
  top: 0px;
  animation-delay: 2s;
}


@keyframes animate {

  0% {
    transform: rotateY(0deg);
  }
  20% {
    transform: rotateY(360deg);
  }
  40% {
    transform: rotateX(180deg);
  }
  60% {
    transform: rotateX(0deg);
  }
  80% {
    transform: rotateX(360deg);
  }
  100% {
    transform: rotateY(180deg);
  }
}

.modal-test {
  max-width: 675px;
}

.recordViewTitle {
  padding-bottom: 7px;
  font-weight: 600;
  font-size: 13px;
  font-family: 'Work Sans', sans-serif;
  margin-bottom: 15px;
  border-bottom: 1px solid #dae6eb;
  color: #253858;
}

.ch-form-element {
  padding: 5px 10px 40px 0;
  margin-bottom: 40px;
  vertical-align: top;
  display: table-cell;
}

input[type="radio"] {
  -webkit-appearance: none;
  width: 14px;
  height: 14px;
  border: 1px solid #4a8df0;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: inset 0 0 3px rgba(0, 168, 255, 0.3);
  transition: all 0.3s ease;
  margin-top: 0;
  position: relative;
  top: 2px;
  margin-right: 3px;
}

input[type="radio"]:checked {
  background: #4a8df0;
  box-shadow: inset 0 0 0px 3px #FFF;
}

.test-modal-body {
  min-height: 400px;
  max-height: auto;
  overflow: auto;
  padding: 8px 25px 25px 25px;
}

.modal-test-height {
  height: 93vh;
  max-width: 700px !important;
}

.modal-test-content {
  height: 100%;
}

.test-model-header {
  font-weight: 600;
  padding: 15px 15px 12px 15px;
  font-size: 13px;
  font-family: 'Work Sans', sans-serif;
}

.record-label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 400;
  margin-right: 15px;
  font-family: 'Work Sans', sans-serif;
  font-size: 13px;
  color: #253858;
}

.record-label input:focus {
  outline: none;
}

.test-query-field {
  padding: 0px 10px;
  font-size: 13px;
  line-height: 1.42857143;
  background-color: #fff;
  background-image: none;
  border-color: transparent;
  border-radius: 0;
  -webkit-box-shadow: inset 0 0 0 transparent;
  box-shadow: inset 0 0 0 transparent;
  -webkit-transition: border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;
  -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  transition: border-color ease-in-out;
  border: 0;
  border-bottom: 1px solid #e7eff3 !important;
  outline: 0 none;
  height: 35px;
  font-weight: 500;
  width: 100%;
  color: #253858;
}

.test-map-fields {
  padding-top: 10px !important;
  vertical-align: top;
  display: table-cell;
  font-family: 'Work Sans', sans-serif;
  font-size: 13px;
  color: #253858;
}

.test-modal-footer .test-btn-light {
  border-radius: 3px;
  font-size: 13px;
  font-weight: 500;
  -webkit-transition: all 0.2s ease-in-out 0s;
  transition: all 0.2s ease-in-out 0s;
  padding: 6px 15px;
  color: #516873;
  background-color: #fff;
  border-color: #e9eced;
  box-shadow: 1px 1px 3px #F1F1F1;
}

.test-modal-footer .test-btn-primary {
  border-radius: 3px;
  font-size: 13px;
  font-weight: 500;
  -webkit-transition: all 0.2s ease-in-out 0s;
  transition: all 0.2s ease-in-out 0s;
  padding: 6px 15px;
  color: #fff;
  background-color: #4b8dee;
  border-color: #4182e1;
  box-shadow: 1px 1px 3px #C3C3C3;
}

.modal-content-box {
  padding: 100px;
}

.custom-check {
  position: relative;
  padding-left: 22px;
  display: flex;
  align-items: center;
}

.custom-check::before {
  content: '';
  width: 18px;
  height: 18px;
  margin-right: 10px;
  border: 1px solid #222;
}

.custom-check::after {
  content: '';
  position: absolute;
  left: 25px;
  display: none;
  top: 6px;
  width: 12px;
  height: 8px;
  transform: rotate(-43deg);
  border-left: 2px solid #222;
  border-bottom: 2px solid #222;
}

.custom-check-input {
  display: none;
}

.custom-check-input:checked ~ .custom-check::after {
  display: block;
}

.item-detail .table-item-detail-select {
  width: 204px;
  outline: none;
  background: transparent;
  border: 1px solid #e1e9ee;
  color: #555;
  height: 30px;
  font-size: 13px;
  font-weight: 400;
  padding: 0 10px;
}

.table-test-result {
  color: #253858;
  font-size: 13px;
}

.table-test-dataRow > td,
.table-test-dataRow > th {
  border: 0 !important;
}

.table-test-dataRow {
  border-bottom: 1px solid #ddd !important;
  empty-cells: show;
}

.test-table-heading > h2::before {
  display: none !important;
}

.test-table-heading > h2 {
  position: relative !important;
  width: auto !important;
  display: inline-block !important;
  margin-left: 20px;
  background: #fff;
}

.test-table-heading > h2::after {
  content: '';
  position: absolute;
  width: 100%;
  left: 0;
  bottom: -4px;
  height: 3px;
  background-color: #4b8dee;
}

.test-table-heading {
  border-bottom: 1px solid #ddd;
}

.modal-footer {
  width: 100%;
}

.h-5 {
  padding: 0 25px !important;
}

.result-success {
  padding-bottom: 7px;
  color: #253858;
}

.test-smulation-modal .nav-link.active::after {
  bottom: 12px !important;
}

.test-table-heading-create-record h2 {
  margin-top: 5px;
  font-size: 20px;
  font-weight: bolder;
  border-bottom: 3px solid #4b8dee;
  float: left;
  padding: 10px 18px;
  margin-bottom: -1px;
}

.no-simulation-result {
  min-height: 200px;
  padding: 20px 35px;
}

.no-simulation-result-heading {
  font-size: 22px;
  color: #f37b14;
  font-weight: bolder;
}

.test-save-btn img {
  height: 18px;
  width: 20px;
  position: sticky;
}

.email-content-btn {
  display: inline-block;
  border: 1px solid #4b8dee;
  padding: 1px 8px;
  font-size: 11px;
  border-radius: 10px;
  font-weight: 500;
}

.email-content-btn:hover {
  text-decoration: underline;
}

.automation-email-modal-dialog {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  top: 18%;
}

.custom-btn-close {
  transform: none !important;
  font-size: 20px !important;
}

#email-content-modal .modal-header {
  border: none;
}

.attachment-heading {
  font-weight: bold;
  font-size: 15px;
}

.display-pdfs-automation {
  font-size: 13px;
  font-weight: 600;
  padding-top: 1px;
}

#test-result-modal.show {
  display: flex !important;
  justify-content: center;
  align-items: center;
}

#automated-section .workflow-modal-body {
  padding: 0 !important;
  height: 77vh;
  border-radius: 6px;
}

#automated-section .workflow-modal-content {
  height: 100%;
}

.simulationResultsuccessDiv {
  height: 100%;
}

.test-modal-tabs-panel {
  height: 100%;
}

.map-fields-container-test-result {
  height: 100% !important;
}

#add-create-record {
  height: 100%;
}

#add-modify-record {
  height: 100%;
}

@media (min-width: 992px) {
  #automated-section .modal-lg-custom {
    min-width: 885px;
  }
}
</style>
<template>
  <div class="page-container">
    <div class="container">
      <div class="alert alert-danger automation-error"></div>
      <div class="automated-timeline-container">
        <div class="automated-timeline">
          <ul class="time-line">
            <li class="time-line-item0">
              <div class="item-title">
                <div class="col-xl-12 col-12">
                  <p class="item-title-title">{{ lang.description }}</p>
                </div>
              </div>
              <div class="item-detail">
                <div class="col-xl-12 col-12">
                                    <textarea class="item-detail-select form-control" style="height: 100px;"
                                              v-model="description"></textarea>
                </div>
              </div>
            </li>
            <li class="time-line-item0">
              <div class="item-title">
                <div class="d-flex flex-wrap">
                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <p class="item-title-title">
                      {{ lang.type }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="item-detail">
                <div class="col-xl-12 col-12">
                  <select class="item-detail-select form-control" v-model="type">
                    <option value="1">{{ lang.one_action_per_record }}</option>
                    <option value="2">{{ lang.one_action_for_multiple_records }}</option>
                  </select>
                </div>
              </div>
            </li>
            <li class="time-line-item1">
              <div class="item-title">
                <div class="d-flex flex-wrap">
                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <p class="item-title-title">
                      {{ lang.when_should }} {{ lang.execute }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="item-detail">
                <div class="col-xl-12 col-12" v-if="queries">
                  <select class="item-detail-select form-control when-selectbox" v-model="when_should"
                          @change="whichWhenChange($event,'when')">
                    <option selected disabled hidden>{{ lang.eg_now_weekly_new_record }}</option>
                    <option v-bind:value="execution_row.id" v-for="execution_row in execution_type">
                      {{ execution_row.execution }}
                    </option>
                  </select>
                </div>
                <div class="col-xl-12 col-12" v-else>
                  <select class="item-detail-select form-control when-selectbox"
                          @change="whichWhenChange($event,'when')">
                    <option selected disabled hidden>{{ lang.eg_now_weekly_new_record }}</option>
                    <option v-bind:value="execution_row.id" v-for="execution_row in execution_type">
                      {{ execution_row.execution }}
                    </option>
                  </select>
                </div>
              </div>
            </li>
            <li class="time-line-item2">
              <div class="item-title">
                <div class="col-xl-12 col-12">
                  <p class="item-title-title">{{ lang.which_records }}</p>
                </div>
              </div>
              <div class="item-detail">
                <div class="col-xl-12 col-12" v-if="queries">
                  <select class="item-detail-select form-control which-selectbox"
                          v-model="which_record" @change="whichWhenChange($event,'which')">
                    <option selected disabled hidden>Eg. {{ lang.contacts }}</option>
                    <option v-for="table in tables" v-bind:value="table.id">
                      {{ table.label ? table.label : table.plural }}
                    </option>
                  </select>
                </div>
                <div class="col-xl-12 col-12" v-else>
                  <select class="item-detail-select form-control which-selectbox"
                          @change="whichWhenChange($event,'which')">
                    <option selected disabled hidden>Eg. {{ lang.contacts }}</option>
                    <option v-for="table in tables" v-bind:value="table.id">
                      {{ table.label ? table.label : table.plural }}
                    </option>
                  </select>
                </div>
              </div>
            </li>
            <li class="time-line-item3">
              <div class="item-title">
                <div class="col-xl-12 col-12">
                  <p class="item-title-title">{{ lang.conditions_and_actions }}</p>
                </div>
              </div>
              <div class="item-detail">
                <div class="col-xl-12 col-12 mb-2" v-for="isSectionActive,level in dynamicDiv"
                     v-if="renderComponent">
                  <div class="automated-con-act">
                    <div class="automation-remove" v-if="level > 0">
                      <button type="button" v-on:click="removeAutomation(level)"
                              class="close close-custom automation-btn-close" aria-label="Close">
                        <span aria-hidden="true" class="automation-remove-icon">&times;</span>
                      </button>
                    </div>
                    <div class="col-xl-12 col-12 px-0">
                      <div class="con-act-title">
                        <p class="con-act-title-p">{{
                            lang.what_conditions_should_be_checked
                          }}</p>
                        <span class="con-act-title-span">{{ lang.eg_city_is }}
	                                            	<span>{{ companyName }}</span>
	                                        	</span>
                      </div>
                      <div class="select-field-condition">
                        <div class="final-selected-condition">
                          <div class="col-xl-12 col-12 px-0 mb-0" v-if="newAutomation.length > 0">
                            <QueryComponent
                                :queries="newAutomation[level]"
                                :RawQueryStructure="RawQueryStructure"
                                :addConditionBtnOccurence="addConditionBtnOccurence"
                                :url="url"
                                :groupId="queries != undefined ? queries.group_id : ''"
                                :db_exactTable_name="db_exactTable_name"
                                :table="table"
                                :tables="tables"
                                :subLevel="queries != undefined ? queries.subLevel : ''"
                                :operator="queries != undefined ? queries.operator : ''"
                                :level="level"
                                :id="queries != undefined ? queries.id : ''"
                                :modal="queries != undefined ? queries.modal : ''"
                                :isGroup="queries != undefined ? queries.isGroup : ''"
                                :tableField="tableField"
                                :having="queries != undefined ? queries.having : ''"
                                :depth="0"
                                :lang="lang"
                                :timeZone="timeZone"
                                :groupCondition="groupCondition"
                                :fieldConcatValue="queries != undefined ? queries.fieldConcatValue : ''"
                                :order="queries != undefined ? queries.order : ''"
                                :fields="fields"
                                :conditions="conditions"
                                :conditionsForNumber="conditionsfornumber"
                                :whenshould="when_should"
                                @ApplyChildFunction="ApplyChildFunction"
                                @automationEditState="automationEditState"
                                @RebulidAutomationQueryTree="RebulidAutomationQueryTree"
                                @UpdateConditionBtnOccurenceArray="UpdateConditionBtnOccurenceArray"
                                @ResetConditionBtnOccurenceArray="ResetConditionBtnOccurenceArray"
                                @SetSubLevelValue="SetSubLevelValue"
                                @groupConditionSelector="groupConditionSelector"
                                @removeQuery="removeQuery"
                                @removeQueryGroup="removeQueryGroup"
                                @emitconditionGroup="emitconditionGroup"
                            />
                          </div>
                        </div>
                        <div class="submit-condition-group">
                          <div v-if="hasQuery(level)">
                            <div class="btn-group"
                                 v-if="when_should !== null && which_record !== null">
                              <button class="btn select-field-condition-modal-open"
                                      v-on:click.stop.prevent="openAutomationModal(level)">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                                {{ lang.select_field_and_Its_condition }}
                              </button>
                            </div>
                            <button class="btn select-field-popup-btn" v-else
                                    v-on:click.stop.prevent="shouldBeChecked()">
                              <i class="fa fa-plus" aria-hidden="true"></i>
                              {{ lang.select_criteria }}
                            </button>
                          </div>
                        </div>
                        <form autocomplete="off" v-click-outside="outside"
                              v-if="isSectionActive.active">
                          <div class="popup-container-main"
                               :id="'popup-container-main-'+level">
                            <div class="popup-container">
                              <div class="popup-search-filter">
                                <input class="form-control table-filter-row-search"
                                       v-on:keyup="searchSubmit($event)"
                                       id="search-keyword" type="Search"
                                       :placeholder="lang.search+'..'">
                                <i class="fa fa-search" aria-hidden="true"></i>
                                <div class="workflow-selected-field"
                                     v-if="selected_text_seen">
                                  <span>{{ lang.select + ' ' + lang.field }}</span>
                                </div>
                              </div>
                              <div class="workflow-accordion-container">
                                <transition name="slide" v-if="selected_accordion_seen">
                                  <accordion-component
                                      :accrodionState="accrodionState"
                                      :tableField="tableField"
                                      :whenQueryEdit="whenQueryEdit"
                                      :savedInput="savedInput"
                                      :level="level"
                                      :tableWithValues="tableWithValues"
                                      :whenshould="when_should"
                                      :table="table"
                                      :tables="tables"
                                      :lang="lang"
                                      :fields="fields"
                                      v-on:getInput="getInput"
                                      v-on:backToprevious="backToprevious"
                                      v-on:listenerChild="listenerChild">
                                  </accordion-component>
                                </transition>
                                <div class="company-selected-section"
                                     v-if="moreCondition">
                                  <img :src="url+'/icons/com-arrow-down.svg'"
                                       v-on:click.stop.prevent="previousCondition()">
                                  <span>
																		{{ fieldTranslationsLabel }}
																	</span>
                                  <div class="row-data-dropdown">
                                    <p class="row-data-selected set-selected-condition">
                                      {{ lang[having] }}
                                    </p>
                                    <b-dropdown class="m-md-2"
                                                name="condition"
                                                v-model="having">
                                      <b-dropdown-item
                                          v-for="condition in GetConditions()"
                                          :key="condition.dropdown_value"
                                          :value="condition.dropdown_value"
                                          @click="having = condition.having">
                                        {{ lang[condition.having] }}
                                      </b-dropdown-item>
                                    </b-dropdown>
                                  </div>
                                  <accordion-component
                                      :accrodionState="accrodionState"
                                      :tableField="tableField"
                                      :whenQueryEdit="whenQueryEdit"
                                      :savedInput="savedInput"
                                      :level="level"
                                      :tableWithValues="tableWithValues"
                                      :whenshould="when_should"
                                      :table="table"
                                      :tables="tables"
                                      v-on:getInput="getInput"
                                      v-on:backToprevious="backToprevious"
                                      :lang="lang"
                                      v-on:listenerChild="listenerChild">
                                  </accordion-component>
                                  <button
                                      class="btn btn-outline-primary btn-apply-condition"
                                      v-on:click.stop.prevent="apply(level)">
                                    {{ lang.apply }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div class="col-xl-12 col-12 mt-4 px-0">
                      <div class="con-act-title task-container">
                        <p class="con-act-title-p">{{
                            lang.what_actions_do_you_want_to_perform
                          }}</p>
                        <span class="con-act-title-span">{{
                            lang.eg_send_mail_create_task_modify_record
                          }}</span>
                      </div>
                      <div class="modal-create-options-container">


                        <div class="modal-create-options"
                             v-for="action in GetActionByLevel(saved_actions, level)">
                          <h2 class="create-record"
                              v-if="Object.keys(action.action_map)[0] == 'create_record'"
                              @click="EditModal('#create-record-modal', action.id, 'saved', level)"
                              data-status="saved">
                            {{ lang.create_record }}
                          </h2>
                          <h2 class="modify-record"
                              v-if="Object.keys(action.action_map)[0] == 'modify_record'"
                              @click="EditModal('#modify-record-modal', action.id, 'saved', level)"
                              data-status="saved">
                            {{ lang.modify_record }}
                          </h2>
                          <h2 class="task-create"
                              v-if="Object.keys(action.action_map)[0] == 'create_task'"
                              @click="EditModal('#create-task-modal', action.id, 'saved', level)"
                              data-status="saved">
                            {{ lang.create_task }}
                          </h2>
                          <h2 class="send-email"
                              v-if="Object.keys(action.action_map)[0] == 'send_email'"
                              @click="EditModal('#send-email-modal', action.id, 'saved', level)"
                              data-status="saved">
                            {{ lang.send_email }}
                          </h2>

                          <i class="fa fa-times fa-times-none"
                             @click="removeAction('saved', action.id, level)"
                             aria-hidden="true"></i>
                        </div>

                        <div class="modal-create-options"
                             v-for="(action, index) in GetActionByLevelUnsaved(action_details, level)">
                          <h2 class="create-record"
                              v-if="Object.keys(action)[0] == 'create_record'"
                              @click="EditModal('#create-record-modal', index, 'temp', level)"
                              data-status="temp">
                            {{ lang.create_record }}
                          </h2>
                          <h2 class="modify-record"
                              v-if="Object.keys(action)[0] == 'modify_record'"
                              @click="EditModal('#modify-record-modal', index, 'temp', level)"
                              data-status="temp">
                            {{ lang.modify_record }}
                          </h2>
                          <h2 class="task-create"
                              v-if="Object.keys(action)[0] == 'create_task'"
                              @click="EditModal('#create-task-modal', index, 'temp', level)"
                              data-status="temp">
                            {{ lang.create_task }}
                          </h2>
                          <h2 class="send-email" v-if="Object.keys(action)[0] == 'send_email'"
                              @click="EditModal('#send-email-modal', index, 'temp', level)"
                              data-status="temp">
                            {{ lang.send_email }}
                          </h2>

                          <i class="fa fa-times fa-times-none"
                             @click="removeAction('temp', index, level)"
                             aria-hidden="true"></i>
                        </div>
                      </div>
                      <div class="dropdown wf-select-down-menu">
                        <button
                            class="btn btn-primary apply-btn-color wf-select-action dropdown-toggle open-action-modal-btn"
                            type="button" id="dropdownMenuButton" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">
                          {{ lang.select_action }}
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <div class="wf-select-dropdown-menu-items">
                            <p>{{ lang.What_do_you_want_to_do_next }}</p>
                            <ul>
                              <div v-if="parseInt(type) === 1">
                                <li><a href="javascript:void(0)"
                                       @click="openModal('#add-create-record', level)"><img
                                    :src="url+'/create-record.svg'">{{ lang.create_record }}</a>
                                </li>
                                <li><a href="javascript:void(0)"
                                       @click="openModal('#add-modify-record', level)"><img
                                    :src="url+'/modify-record.svg'">{{ lang.modify_record }}</a>
                                </li>
                                <li><a href="javascript:void(0)"
                                       @click="openModal('#add-create-task', level)"><img
                                    :src="url+'/create-task.svg'">{{ lang.create_task }}</a>
                                </li>
                              </div>
                              <li><a href="javascript:void(0)"
                                     @click="openModal('#add-send-email', level)"><img
                                  :src="url+'/send-email.svg'">{{ lang.send_email }}</a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <p class="add-automated-another ml-5">
              <a href="javascript:void(0)" @click="dynamicDivCreator()"><i
                  class="fa fa-plus auto-plus-add-g" aria-hidden="true"></i>{{
                  lang.add_another_condition
                }}</a>
            </p>
            <li class="ls-none">
              <div class="item-title">
                <button type="button" class="btn btn-danger apply-btn-color test-save-btn"
                        v-if="when_should != 2 && when_should != 1 && when_should != 6"
                        v-on:click.stop.prevent="openTestModal()">
                  <!-- <i class="fa fa-flask" aria-hidden="true"></i>  -->
                  <img :src="url+'/icons/test.svg'">
                  {{ lang.test_and_save }}
                </button>
                <button type="button" class="btn btn-danger apply-btn-color test-save-btn"
                        v-else-if="when_should == 1 || when_should == 6"
                        v-on:click.stop.prevent="openTestModal()">
                  <img :src="url+'/icons/test.svg'">
                  {{ lang.execute }}
                </button>
                <button type="button" class="btn btn-danger apply-btn-color test-save-btn" v-if="when_should == 2"
                        v-on:click.stop.prevent="openTestModal()" data-toggle="modal"
                        data-target="#cron-modal">
                  <img :src="url+'/icons/test.svg'">
                  {{ lang.test_and_schedule }}
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div>
      <!-- Button trigger modal -->
      <!-- Modal -->
      <div class="modal fade" id="cron-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
           aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header automation-modal-header">
              <p class="automation-modal-title text-center">{{ lang.save }} {{ lang.cron }}</p>
              <button type="button" class="close close-custom" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body automated-modal-body">
              <form class="automation-schedule-form">
                <div class="automation-schedule-form-container">
                  <div class="auto-schedule-label">
                    <label>{{ lang.cron }} {{ lang.label }}<sup>*</sup></label>
                    <input v-model="cron_settings.cron_label.value"
                           v-bind:class="{ 'is-invalid': cron_settings.cron_label.error == true  }"
                           type="text" class="automation-schedule-input">
                  </div>
                  <div class="auto-schedule-name">
                    <label>{{ lang.cron }} {{ lang.name }}<sup>*</sup></label>
                    <input v-model="cron_settings.cron_name.value"
                           v-bind:class="{ 'is-invalid': cron_settings.cron_name.error == true  }"
                           type="text" class="automation-schedule-input">
                  </div>
                  <div class="auto-schedule-day-month">
                    <label>{{ lang.cron }} {{ lang.schedule }}<sup>*</sup></label>
                    <span
                        v-bind:class="{ addCheckCronSettings: cron_settings.cron_schedule.value == 'daily_weekly', 'is-invalid': cron_settings.cron_schedule.error == true }"
                        @click="SetCronSchedule('daily_weekly')" class="auto-schedule-day">
									{{ lang.daily_weekly }}
								</span>
                    <span
                        v-bind:class="{ addCheckCronSettings: cron_settings.cron_schedule.value == 'monthly', 'is-invalid': cron_settings.cron_schedule.error == true }"
                        @click="SetCronSchedule('monthly')" class="auto-schedule-month">
									{{ lang.monthly }}
								</span>
                  </div>
                  <div class="auto-schedule-select-days" v-if="daysOf">
                    <label>{{ lang.day_of_week }}<sup>*</sup></label>
                    <ul class="custom-cron-multi-select">
                      <li v-for="day in days_of_week"
                          v-bind:class="{ selected: CheckCronTimingSelected(day.value) }"
                          @click="SelectCronTiming(day.value)">
                        {{ lang.day_of_week_cron[day.value] }}
                      </li>
                    </ul>
                  </div>
                  <div class="auto-schedule-select-days" v-else>
                    <label>{{ lang.day_of_month }}<sup>*</sup></label>
                    <ul class="custom-cron-multi-select">
                      <li v-for="day in days_of_month"
                          v-bind:class="{ selected: CheckCronTimingSelected(day.value) }"
                          @click="SelectCronTiming(day.value)">
                        {{ day.value }}
                      </li>
                    </ul>
                  </div>
                  <div class="auto-schedule-select-time">
                    <label>{{ lang.time }}<sup>*</sup></label>
                    <VueCtkDateTimePicker
                        format="HH:mm"
                        formatted="HH:mm"
                        :only-time="true"
                        :locale="lang.code"
                        :button-now-translation="lang.now"
                        v-model="cron_settings.cron_execution_time.value"
                        :error="cron_settings.cron_execution_time.error"
                        :no-label="true"
                        label="Select time"
                        :position="'bottom'"
                    />
                  </div>
                  <div class="auto-schedule-select-date-start">
                    <label>{{ lang.start }} {{ lang.date }}<sup>*</sup></label>
                    <VueCtkDateTimePicker
                        :format="setDynamicFormat()"
                        :formatted="setDynamicFormat()"
                        :only-date="true"
                        v-model="cron_settings.cron_execution_start_date.value"
                        :error="cron_settings.cron_execution_start_date.error"
                        :no-label="true"
                        :locale="lang.code"
                        :no-button-now="true"
                        :button-now-translation="lang.now"
                        :label="lang.select+' '+lang.date"
                        :position="'bottom'"
                    />
                  </div>
                  <div class="auto-schedule-select-date-end">
                    <label>{{ lang.end }} {{ lang.date }}<sup>*</sup></label>
                    <VueCtkDateTimePicker
                        :disabled="hasDisabled()"
                        :format="setDynamicFormat()"
                        :formatted="setDynamicFormat()"
                        :only-date="true"
                        :no-button-now="true"
                        :locale="lang.code"
                        :button-now-translation="lang.now"
                        :min-date="setMinDate(cron_settings.cron_execution_start_date.value)"
                        v-model="cron_settings.cron_execution_end_date.value"
                        :error="cron_settings.cron_execution_end_date.error"
                        :no-label="true"
                        :label="lang.select+' '+lang.date"
                        :position="'bottom'"
                    />
                    <p v-if="cron_settings.cron_execution_end_date.error" class="error-text">Start
                      can't be greater than End Date</p>
                  </div>
                </div>
              </form>
            </div>
            <div class="automation-modal-footer">
              <button type="button" class="btn schedule-save" @click="SaveAction()">
                {{ lang.save }}
              </button>
              <button type="button" class="btn schedule-cancel" data-dismiss="modal">
                {{ lang.cancel }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Test Modal Start-->
      <div class="modal fade" id="test-modal" tabindex="-1" role="dialog" aria-labelledby="testModalLabel"
           aria-hidden="true">
        <div class="modal-dialog modal-test modal-test-height" role="document">
          <div class="modal-test-content modal-content">
            <div class="modal-header test-model-header">
              {{ lang.fill_test_data }}
            </div>

            <div class="modal-body test-modal-body">
              <div>
                <div class="recordViewTitle">{{ lang.what_do_test }}</div>
              </div>
              <div class="ch-form-grid">
                <div class="ch-form-element-group">
                  <div class="ch-form-element">
                    <label class="record-label">
                      <input type="radio" @click="toggleDiv()" checked name="triggerTestOperation"
                             value="Insert">
                      {{ lang.create_new_record }}
                    </label>
                    <label class="record-label">
                      <input type="radio" @click="toggleDiv()" name="triggerTestOperation"
                             value="Update">
                      {{ lang.update_existing_record }}
                    </label>
                  </div>
                </div>
              </div>
              <form class="ch-form" id="querySimulationForm" autocomplete="off">
                <div id="data-Insert" v-if="showTestOperationDiv">

                </div>
                <div id="data-Update" :style="mb5" v-else>
                  <div class="row">
                    <div class="col-md-4 d-flex align-items-center justify-content-end">
                      <div class="test-map-fields">
                        {{ lang.choose }} {{ table }} {{ lang.record }}
                        <sup class="text text-danger">*</sup>
                      </div>
                    </div>
                    <form autocomplete="off" v-click-outside="outside"
                          v-if="oldRecordDropDownModal">
                      <div class="popup-container-main" id="popup-container-main"
                           style="top: 160px;">
                        <div class="popup-container">
                          <div class="popup-search-filter">
                            <input class="form-control table-filter-row-search"
                                   v-on:keyup="searchSubmit($event)" id="search-keyword"
                                   type="Search" :placeholder="lang.search+' '+table+'...'">
                            <i class="fa fa-search" aria-hidden="true"></i>
                          </div>
                          <div class="workflow-accordion-container">
                            <div class="company-selected-section">
                              <div class="card">
                                <div class="card-body">
                                  <div id="filterSearch" class="workflow-row-details">
                                    <ul>
                                      <li v-for="TableOldRecord in TableOldRecords">
                                        <a @click="setOldData(TableOldRecord)"
                                           href="javascript:void(0)">
                                          {{
                                            TableOldRecord.name != undefined ? TableOldRecord.name : TableOldRecord.id
                                          }}
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    <div class="col-md-6 d-flex align-items-center">
                      <i class="fa fa-search text-success" aria-hidden="true"></i>
                      <input type="text"
                             @click="getTableOldData()"
                             :value="oldRecordInput"
                             :placeholder="lang.search+'..'"
                             class="test-query-field">
                    </div>
                  </div>
                </div>

                <div class="OldRecordDivIsOpen">
                  <div v-if="SelectedTable.label" class="recordViewTitle">
                    {{ table }} {{ lang.details }}
                  </div>
                  <div class="workflow-map-fields">
                    <div v-for="field in SelectedTable.fields" class="workflow-map-fields-items">
                      <SelectedTableSimulationForm
                          v-if="renderComponentTestModal"
                          :SelectedTable="SelectedTable"
                          :field="field"
                          :Auth="auth"
                          :lang="lang"
                          :companies="companies"
                          :simulationFormData="simulationFormData"
                          v-on:simulationFormDataEvent="simulationFormDataEvent"
                      >
                      </SelectedTableSimulationForm>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="modal-footer test-modal-footer">
              <button type="button" class="btn btn-light test-btn-light" data-dismiss="modal">
                {{ lang.cancel }}
              </button>
              <button type="submit" class="btn btn-primary apply-btn-color test-btn-primary"
                      @click="openTestResultModal()">
                {{ lang.test }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Test Modal End -->


      <!-- Test Result Modal Start for Now and Cron -->

      <div class="modal fade" id="test-result-modal" tabindex="-1" role="dialog"
           aria-labelledby="testResultModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg-custom modal-lg-custom-res" role="document">
          <div class="modal-content">
            <div class="modal-header test-model-header">
              {{ lang.test_results }}
            </div>
            <div v-if="showTestResultDiv">
              <div class="no-simulation-result" v-if="noSimulationResult">
                <div class="no-simulation-result-heading">{{ lang.nothing_validated }}</div>
                <p>{{ lang.because }}</p>
                <ol>
                  <li>{{ lang.nothing_In_tables }}</li>
                  <li>{{ lang.suggestion_of_filter }}</li>
                </ol>
              </div>
              <div class="modal-body workflow-modal-body workflow-modal-body-height" v-else>
                <div class="border-body-right-top"></div>
                <div class="workfloww-tab-main-container">

                  <div class="success-result-sidebar" v-if="simulationResultHasSuccess()">
                    <p class="msg px-1 border-bottom border-black mx-2 result-success">
                      <i class="fa fa-check-circle fa-lg text-success"></i>
                      {{ lang.success }}
                    </p>

                    <ul class="nav nav-tabs workflow-modal-nav test-smulation-modal" id="myTab"
                        role="tablist" v-if="checkHasSimulation()">
                      <li class="nav-item" v-for="(result,actionType) in simulationResult">
                        <a class="nav-link test-modal-tabs"
                           v-if="actionType == 'create_record' && simulationResult.create_record.success.length > 0"
                           :id="'add-'+actionType+'-tab-success'" data-toggle="tab"
                           :href="'#'+actionType+'success'"
                           @click="openAction('simulationResultsuccessDiv',actionType,'success')"
                           role="tab" :aria-controls="actionType" aria-selected="true">
                          {{ lang.records_being_created }}
                        </a>
                        <a class="nav-link test-modal-tabs"
                           v-if="actionType == 'modify_record' && simulationResult.modify_record.success.length > 0"
                           :id="'add-'+actionType+'-tab-success'" data-toggle="tab"
                           :href="'#'+actionType+'success'"
                           @click="openAction('simulationResultsuccessDiv',actionType,'success')"
                           role="tab" :aria-controls="actionType" aria-selected="true">
                          {{ lang.records_being_updated }}
                        </a>
                        <a class="nav-link test-modal-tabs"
                           v-if="actionType == 'send_email' && simulationResult.send_email.success.length > 0"
                           :id="'add-'+actionType+'-tab-success'" data-toggle="tab"
                           :href="'#'+actionType+'success'"
                           @click="openAction('simulationResultsuccessDiv',actionType,'success')"
                           role="tab" :aria-controls="actionType" aria-selected="true">
                          {{ lang.email_being_sent }}
                        </a>
                        <a class="nav-link test-modal-tabs"
                           v-if="actionType == 'create_task' && simulationResult.create_task.success.length > 0"
                           :id="'add-'+actionType+'-tab-success'" data-toggle="tab"
                           :href="'#'+actionType+'success'"
                           @click="openAction('simulationResultsuccessDiv',actionType,'success')"
                           role="tab" :aria-controls="actionType" aria-selected="true">
                          {{ lang.task_being_created }}
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div class="error-result-sidebar" v-if="simulationResultHasError()"
                       style="padding-top: 24px;">
                    <p class="msg px-1 border-bottom border-black mx-2 result-success">
                      <i class="fa fa-exclamation-circle fa-lg text-danger"></i>
                      {{ lang.failed }}
                    </p>

                    <ul class="nav nav-tabs workflow-modal-nav test-smulation-modal" id="myTab"
                        role="tablist" v-if="checkHasSimulation()">
                      <li class="nav-item" v-for="(result,actionType) in simulationResult">
                        <a class="nav-link test-modal-tabs text text-danger"
                           v-if="actionType == 'create_record' && simulationResult.create_record.error.length > 0"
                           :id="'add-'+actionType+'-tab-error'" data-toggle="tab"
                           :href="'#'+actionType+'error'"
                           @click="openAction('simulationResulterrorDiv',actionType,'error')"
                           role="tab" :aria-controls="actionType" aria-selected="true">
                          {{ lang.records_not_being_created }}
                        </a>
                        <a class="nav-link test-modal-tabs text text-danger"
                           v-if="actionType == 'modify_record' && simulationResult.modify_record.error.length > 0"
                           :id="'add-'+actionType+'-tab-error'" data-toggle="tab"
                           :href="'#'+actionType+'error'"
                           @click="openAction('simulationResulterrorDiv',actionType,'error')"
                           role="tab" :aria-controls="actionType" aria-selected="true">
                          {{ lang.records_not_being_updated }}
                        </a>
                        <a class="nav-link test-modal-tabs text text-danger"
                           v-if="actionType == 'send_email' && simulationResult.send_email.error.length > 0"
                           :id="'add-'+actionType+'-tab-error'" data-toggle="tab"
                           :href="'#'+actionType+'error'"
                           @click="openAction('simulationResulterrorDiv',actionType,'error')"
                           role="tab" :aria-controls="actionType" aria-selected="true">
                          {{ lang.email_not_being_sent }}
                        </a>
                        <a class="nav-link test-modal-tabs text text-danger"
                           v-if="actionType == 'create_task' && simulationResult.create_task.error.length > 0"
                           :id="'add-'+actionType+'-tab-error'" data-toggle="tab"
                           :href="'#'+actionType+'error'"
                           @click="openAction('simulationResulterrorDiv',actionType,'error')"
                           role="tab" :aria-controls="actionType" aria-selected="true">
                          {{ lang.task_not_being_created }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="tab-content workflow-modal-content" id="myTabContent">
                  <div class="simulationResultsuccessDiv" style="display: none;">
                    <div v-for="(result,actionType) in simulationResult" style="display: none"
                         :id="actionType+'success'"
                         v-if="checkHasSimulation() && checkHasDataSuccess(simulationResult,actionType)"
                         role="tabpanel" :aria-labelledby="actionType+'-tab'"
                         class='tab-pane fade test-modal-tabs-panel'>

                      <div class="workflow-create-header test-table-heading"
                           v-if="actionType == 'modify_record' && simulationResult.modify_record.success.length > 0">
                        <h2 v-if="SelectedTable.label">{{ SelectedTable.label }}</h2>
                      </div>
                      <div class="workflow-create-header test-table-heading"
                           v-if="actionType == 'create_task' && simulationResult.create_task.success.length > 0">
                        <h2>{{ lang.tasks }}</h2>
                      </div>
                      <div class="workflow-create-header test-table-heading"
                           v-if="actionType == 'send_email' && simulationResult.send_email.success.length > 0">
                        <h2>{{ lang.email }}</h2>
                      </div>

                      <div class="workflow-map-fields-container map-fields-container-test-result">
                        <div
                            class="test-table-heading-create-record"
                            v-if="actionType == 'create_record' && simulationResult.create_record.success.length > 0"
                        >
                          <div
                              v-for="(create_record, key_table) in FormatSimulationCreateRecords(simulationResult.create_record.success)">
                            <h2>{{ key_table }}</h2>

                            <table class="table table-test-result"
                                   v-if="actionType == 'create_record' && simulationResult.create_record.success.length > 0">
                              <thead>
                              <tr>
                                <th v-for="(records,fieldName) in create_record[0]['new']"
                                    scope="col"> {{ fieldName }}
                                </th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr class="table-test-dataRow"
                                  v-for="_value in create_record">
                                <td v-for="( record, value) in _value.new">
                                  {{ record != null ? record : 'null' }}
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <table class="table table-test-result"
                               v-if="actionType == 'modify_record' && simulationResult.modify_record.success.length > 0">
                          <thead>
                          <tr class="table-test-dataRow">
                            <th scope="col"
                                v-for="(records,field_name) in simulationResult.modify_record['success'][0]['new']">
                              {{ field_name }}
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr class="table-test-dataRow"
                              v-for="records in simulationResult.modify_record.success">
                            <td v-for="( record, field_name) in records.new">
																<span v-if="record != records.old[field_name]">
																	<strike style="color: grey;">
																		{{
                                      records.old[field_name] != null ? records.old[field_name] : 'null'
                                    }}
																	</strike>
																</span>
                              <span v-else>
																	{{ record != null ? record : 'null' }}
																</span>
                              <br>
                              {{ record != null ? record : 'null' }}
                            </td>
                          </tr>
                          </tbody>
                        </table>

                        <table class="table table-test-result"
                               v-if="actionType == 'create_task' && simulationResult.create_task.success.length > 0">
                          <thead>
                          <tr class="table-test-dataRow">
                            <th scope="col"
                                v-for="(records,fieldName) in simulationResult.create_task['success'][0]">
                              {{ fieldName }}
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr class="table-test-dataRow"
                              v-for="tasks in simulationResult.create_task.success">
                            <td v-for="( task, value) in tasks">
                              {{ task }}
                            </td>
                          </tr>
                          </tbody>
                        </table>

                        <table class="table table-test-result"
                               v-if="actionType == 'send_email' && simulationResult.send_email.success.length > 0">
                          <thead>
                          <tr class="table-test-dataRow">
                            <th scope="col"
                                v-for="(records,fieldName) in simulationResult.send_email['success'][0]">
                              {{
                                lang[fieldName] != undefined ? lang[fieldName] : fieldName
                              }}
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr class="table-test-dataRow"
                              v-for="mails in simulationResult.send_email.success">
                            <td v-for="( mail, value) in mails">
																<span v-if="value == 'content'">
																	<button class="text-primary
																			btn btn-sm email-content-btn"
                                          @click="contentTemplate(mails)">
																		{{ lang.view }}
																	</button>
																</span>
                              <span v-else>
																	{{ mail }}
																</span>
                            </td>
                          </tr>
                          </tbody>
                        </table>

                      </div>
                    </div>
                  </div>
                  <div class="simulationResulterrorDiv" style="display: none;">
                    <div v-for="(result,actionType) in simulationResult" :id="actionType+'error'"
                         v-if="checkHasSimulation() && checkHasDataError(simulationResult,actionType)"
                         role="tabpanel" :aria-labelledby="actionType+'-tab'" style="display: none"
                         class='tab-pane fade 		test-modal-tabs-panel'>

                      <div class="workflow-create-header test-table-heading"
                           v-if="actionType == 'modify_record' && simulationResult.modify_record.error.length > 0">
                        <h2 v-if="SelectedTable.label">{{ SelectedTable.label }}</h2>
                      </div>
                      <div class="workflow-create-header test-table-heading"
                           v-if="actionType == 'create_task' && simulationResult.create_task.error.length > 0">
                        <h2>{{ lang.tasks }}</h2>
                      </div>
                      <div class="workflow-create-header test-table-heading"
                           v-if="actionType == 'send_email' && simulationResult.send_email.error.length > 0">
                        <h2>{{ lang.email }}</h2>
                      </div>

                      <div class="workflow-map-fields-container h-5">
                        <div
                            class="test-table-heading-create-record"
                            v-if="actionType == 'create_record' && simulationResult.create_record.error.length > 0"
                        >
                          <div
                              v-for="(create_record, key_table) in FormatSimulationCreateRecords(simulationResult.create_record.error)">
                            <h2>{{ key_table }}</h2>

                            <table class="table table-test-result"
                                   v-if="actionType == 'create_record' && simulationResult.create_record.error.length > 0">
                              <thead>
                              <tr>
                                <th v-for="(records,fieldName) in create_record[0]['new']"
                                    scope="col">{{ fieldName }}
                                </th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr class="table-test-dataRow"
                                  v-for="_value in create_record">
                                <td v-for="( record, value) in _value.new">
                                  {{ record ? record : 'null' }}
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <table class="table table-test-result"
                               v-if="actionType == 'modify_record' && simulationResult.modify_record.error.length > 0">
                          <thead>
                          <tr class="table-test-dataRow">
                            <th scope="col"
                                v-for="(records,fieldName) in simulationResult.modify_record['error'][0]['new']">
                              {{ fieldName }}
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr class="table-test-dataRow"
                              v-for="records in simulationResult.modify_record.error">
                            <td v-for="( record, value) in records.new">
																<span>
																	{{ record ? record : 'null' }}
																</span>
                            </td>
                          </tr>
                          </tbody>
                        </table>

                        <table class="table table-test-result"
                               v-if="actionType == 'create_task' && simulationResult.create_task.error.length > 0">
                          <thead>
                          <tr class="table-test-dataRow">
                            <th scope="col"
                                v-for="(records,fieldName) in simulationResult.create_task['error'][0]">
                              {{ fieldName }}
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr class="table-test-dataRow"
                              v-for="tasks in simulationResult.create_task.error">
                            <td v-for="( task, value) in tasks">
                              {{ task }}
                            </td>
                          </tr>
                          </tbody>
                        </table>

                        <table class="table table-test-result"
                               v-if="actionType == 'send_email' && simulationResult.send_email.error.length > 0">
                          <thead>
                          <tr class="table-test-dataRow">
                            <th scope="col"
                                v-for="(records,fieldName) in simulationResult.send_email['error'][0]">
                              {{
                                lang[fieldName] != undefined ? lang[fieldName] : fieldName
                              }}
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr class="table-test-dataRow"
                              v-for="mails in simulationResult.send_email.error">
                            <td v-for="( mail, value) in mails">
																<span v-if="value == 'content'">
																	<button class="text-primary
																			btn btn-sm email-content-btn"
                                          @click="contentTemplate(mails)">
																		{{ lang.view }}
																	</button>
																</span>
                              <span v-else>
																	{{ mail }}
																</span>
                            </td>
                          </tr>
                          </tbody>
                        </table>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default wf-modal-cancel" data-dismiss="modal">
                  {{ lang.cancel }}
                </button>
                <button type="button"
                        class="btn btn-primary apply-btn-color wf-modal-save"
                        @click="toggleResultDiv()"
                        v-if="!CheckNoSimulationReturn() && simulationResultState">
                  {{ lang.save }}
                </button>
                <button type="button" v-else :disabled="!simulationResultState"
                        class="btn btn-primary apply-btn-color wf-modal-save">
                  {{ lang.save }}
                </button>
              </div>
            </div>
            <div v-else>
              <div class="modal-content-box">
                <label class="font-weight-bold">{{ lang.terms_condition }}</label>
                <ol>
                  <li>{{ lang.terms_one }}</li>
                  <li>{{ lang.terms_two }}</li>
                </ol>
                <input type="checkbox" class="custom-check-input" id="check"
                       v-model="agreeTermExecuteNow">
                <label class="custom-check" for="check">
                  <span>{{ lang.checkbox_agreement }}</span>
                </label>
                <div style="padding-top: 50px;" class="pull-right">
                  <a href="javascript:void(0);" @click="toggleResultDiv()" class="btn btn-default">
                    {{ lang.back }}
                  </a>
                  <button href="javascript:void(0);" :disabled="!agreeTermExecuteNow"
                          class="btn btn-primary apply-btn-color"
                          @click="executeAutomation(automationId,SelectedOldRecord)"
                          id="execute-button">
                    {{ lang.save }}
                  </button>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Test Result Modal End -->


      <!-- Test Result Modal Start for create and modify -->


      <!-- Test Result Modal End -->

    </div>

    <div class="automation_loader_container" v-if="loading">
      <div class="automation_loader">
        <span class="automation_loader_object"></span>
        <span class="automation_loader_object"></span>
        <span class="automation_loader_object"></span>
        <span class="automation_loader_object"></span>
      </div>
    </div>

    <!-- Email content modal start-->

    <div class="modal fade" id="email-content-modal" data-backdrop="" data-keyboard="false" tabindex="-1"
         role="dialog" aria-labelledby="emailContentLabel" aria-hidden="true">
      <div class="modal-dialog automation-email-modal-dialog modal-lg" role="emaildocument">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close close-custom custom-btn-close" data-dismiss="modal"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="content-holder" v-html="emailContentHtml"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Email content modal end-->

    <CreateRecordModal
        v-on:UpdateCreateRecordActionEvent="UpdateCreateRecordAction"
        :lang="lang"
        :whenshould="when_should"
        :SelectedTableExcludedColumnList="SelectedTableExcludedColumnListReationship"
        v-bind:entity_id="edit_action_entity_id"
        ref="EditCreateActionModal"
        :SelectedTableId="which_record"
        :Auth="auth"
    />
    <ModifyRecordModal
        v-on:UpdateModifyRecordActionEvent="UpdateModifyRecordAction"
        :lang="lang"
        :whenshould="when_should"
        :SelectedTableExcludedColumnList="SelectedTableExcludedColumnListReationship"
        v-bind:entity_id="edit_action_entity_id"
        ref="EditModifyActionModal"
        :Auth="auth"
    />
    <CreateTaskModal
        v-on:UpdateTaskActionEvent="UpdateTaskAction"
        :lang="lang"
        v-bind:entity_id="edit_action_entity_id"
        ref="EditTaskActionModal"
        :categories="categories"
        :SelectedTableId="which_record"
        :Auth="auth"
        :level="action_for_level"
        :SelectedTableExcludedColumnList="SelectedTableExcludedColumnListReationship"
    />
    <SendEmailModal
        v-on:UpdateEmailActionEvent="UpdateEmailAction"
        :lang="lang"
        :whenshould="when_should"
        :level="action_for_level"
        :TemplateList="TemplateList"
        v-bind:entity_id="edit_action_entity_id"
        :SelectedTableExcludedColumnListEmail="SelectedTableExcludedColumnListEmail"
        ref="EditEmailActionModal"
        :SelectedTableId="which_record"
        :SelectedTable="SelectedTable"
    />
    <ActionModal
        :url="url"
        :categories="categories"
        :whenshould="when_should"
        v-on:saveActionEvent="SaveActionData"
        :lang="lang"
        :TemplateList="TemplateList"
        :level="action_for_level"
        :SelectedTableExcludedColumnListReationship="SelectedTableExcludedColumnListReationship"
        :SelectedTableExcludedColumnListEmail="SelectedTableExcludedColumnListEmail"
        :Auth="auth"
        :SelectedTableId="which_record"
    />

  </div>
</template>

<script>

import axios from 'axios';
import uniqid from "uniqid";

/*child component start*/

import AccordionComponent from './AccordionComponent.vue';
import AccordionForModifyRecord from './AccordionForModifyRecord.vue';
import ActionModal from './automation/ActionModalComponent.vue';
import ScheduleModal from './automation/ActionScheduleComponent.vue';
import CreateRecordModal from './automation/CreateRecord.vue';
import ModifyRecordModal from './automation/ModifyRecordModal.vue';
import CreateTaskModal from './automation/CreateTaskModal.vue';
import SendEmailModal from './automation/SendEmailModal.vue';
import QueryComponent from './automation/QueryComponent.vue';
import SelectedTableSimulationForm from './SelectedTableSimulationForm';
import moment from 'moment';

/*child component end*/

export default {
  components: {
    AccordionComponent,
    AccordionForModifyRecord,
    ActionModal,
    CreateRecordModal,
    ModifyRecordModal,
    CreateTaskModal,
    SendEmailModal
  },
  props: [
    'conditions',
    'conditionsfornumber',
    'queries',
    'raw_queries',
    'group_conditions',
    'execution',
    'url',
    'saved_actions',
    'categories', // Task table Categories
    'auth',
    'lang',
  ],
  data() {
    return {
      propQueries: this.queries,
      dynamicDiv: [{
        active: false,
      }],
      simulationResult: [],
      OldRecordDivIsOpen: true,
      showTestOperationDiv: true,
      showTestResultDiv: true,
      showTestRecordResultDiv: true,
      mb5: 'margin-bottom: 0px',
      oldRecordInput: null,
      SelectedOldRecord: [],
      SelectedNewrecord: [],
      TableOldRecords: [],
      oldRecordDropDownModal: false,
      conditionsForNumber: this.conditionsfornumber,
      companyName: 'New York', // example name Ed. City is {{ New York }}
      selected_accordion_seen: true,
      moreCondition: false, // for second section show of accordion
      accrodionState: 1, // state of accordion
      description: null, // for input description
      type: 1, // for input type
      when_should: null, // execution_type id
      which_record: null, // selected table id
      SelectedTable: [], // selected table data
      table: null, // selected table name
      selected_text_seen: true,
      having: 'is', // for top dropdown
      tableField: null, // for first section field selection
      tableField_id: null,
      fieldConcatValue: null,
      automations: [], // automation json
      default_automation: [], // this will be the default state for level generation
      levelCustom: 0,
      tables: null, // All tables of database ajax
      execution_type: null, // All excution type of database ajax
      fields: null, // selected table fields name
      tableWithValues: null,
      db_exactTable_name: null, // exact table name which is added on DB
      renderComponent: true,
      selectedOrInputValue: null,
      check_not_empty: 0,
      SavedLevel: [],
      savedInput: null,
      automationId: null,
      whenQueryEdit: null,
      RemoveQuriesList: [],
      has_value: 0,
      selected_field_type: null,
      cron_settings: {
        cron_label: {value: null, error: false},
        cron_name: {value: null, error: false},
        cron_schedule: {value: null, error: false},
        cron_days_schedule: {value: [], error: false},
        cron_execution_time: {value: new Date().getHours() + ":" + new Date().getMinutes(), error: false},
        cron_execution_start_date: {value: null, error: false},
        cron_execution_end_date: {value: null, error: false},
      },
      days_of_week: [
        {value: 'Sunday'},
        {value: 'Monday'},
        {value: 'Tuesday'},
        {value: 'Wednesday'},
        {value: 'Thursday'},
        {value: 'Friday'},
        {value: 'Saturday'},
      ],
      days_of_month: [],
      daysOf: true,
      cron_days_schedule: true,
      action_modal_active: false,
      action_details: [],
      action_for_level: null,
      // edit states
      edit_action_entity_id: null,
      actions_to_be_removed_ids: [],
      RawQueryStructure: [],
      GlobalQueryParentId: null, // set Id when click add automation
      OrderId: 0,
      subLevel: 0,
      newAutomation: [],
      FormatedQueries: [],
      SelectedTableExcludedColumnListEmail: [],
      SelectedTableExcludedColumnListReationship: [],
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      addConditionBtnOccurence: [],
      groupCondition: [],
      groupIndexRecords: [],
      RemoveQueryGroupIds: [],
      loading: false,
      agreeTermCreateModify: false,
      agreeTermExecuteNow: false,
      executeNowSimulationActiveTab: null,
      companies: [],
      simulationFormData: [],
      renderComponentTestModal: true,
      simulationResultState: true,
      noSimulationResult: false,
      simulationFormState: 'created',
      TemplateList: [],
      fieldTranslationsLabel: null,
      emailContentHtml: null,
      conditionRecordType: null,
      conditionTranslationsLabel: null,

      TaskTableData: [],
    }
  },
  computed: {
    Queries() {
      return _.orderBy(this.RawQueryStructure, 'order', 'desc');
    }
  },
  beforeUpdate() {
    this.ResetConditionBtnOccurenceArray();
  },
  activated: function () {
    this.addConditionBtnOccurence = [];
  },
  beforeMount() {

  },
  mounted() {
    if (this.raw_queries) {
      this.RawQueryStructure = this.raw_queries;
      this.groupCondition = this.group_conditions;

      if (this.RawQueryStructure.length > 0) {

        this.SavedLevel = [...new Set(this.RawQueryStructure.map(x => x.level))];

        if (this.SavedLevel.length > 0) {
          for (var i = 1; i < this.SavedLevel.length; i++) {
            this.dynamicDiv.push({
              active: false
            });
          }
        }
      }
    }
    axios.post('/get-tables-execution-type').then(response => {
      this.tables = response.data.tables;
      this.execution_type = response.data.execution_type;
    });

    this.GetTaskTableData();

    this.outside();
    // ----------------------for automation edit start---------------

    if (this.execution) {
      this.description = this.execution.description;
      this.when_should = this.execution.when_should;
      this.which_record = this.execution.which_record;
      this.type = this.execution.type;

      this.table = this.execution.table.label;
      this.db_exactTable_name = this.execution.table.plural;
      this.automationId = this.execution.automation_id;
      this.getTableFields(this.execution.which_record);
      this.getTemplates();
    }

    this.RebulidAutomationQueryTree();
    this.DaysOfMonth();
    this.existingCompanies();

    // get the values of the present table
    if (this.which_record) {
      axios.post('/selected-table', {'table_id': this.which_record}).then(response => {
        if (response.data.success) {
          this.SelectedTable = response.data.result;
          this.SelectedTableExcludedColumnListEmail = response.data.result.SelectedTableExcludedColumnListEmail;
          this.SelectedTableExcludedColumnListReationship = response.data.result.SelectedTableExcludedColumnListReationship;
          this.simulationFormData = [];
          this.createObjectForSimulationForm(this.SelectedTable.fields, this.simulationFormData);
        }
      });

      this.getTemplates();
    }

    // -------------------------for automation edit end---------------------------
  },
  created() {
    // console.log(this.auth.formatting);
  },
  watch: {},
  methods: {
    CheckNoSimulationReturn() {
      if (
          (this.simulationResult.create_record != undefined && (this.simulationResult.create_record.success.length != 0 || this.simulationResult.create_record.error.length != 0)) ||
          (this.simulationResult.create_task != undefined && (this.simulationResult.create_task.success.length != 0 || this.simulationResult.create_task.error.length != 0)) ||
          (this.simulationResult.modify_record != undefined && (this.simulationResult.modify_record.success.length != 0 || this.simulationResult.modify_record.error.length != 0)) ||
          (this.simulationResult.send_email != undefined && (this.simulationResult.send_email.success.length != 0 || this.simulationResult.send_email.error.length != 0))
      ) {
        return false;
      }
      return true;
    },
    getTemplates() {
      axios.post('/get-template', {'table_id': this.which_record}).then(response => {
        this.TemplateList = response.data;
      });
    },
    openAction(whichSection, actionType, state) {

      if (state == 'success') {

        document.querySelector('.simulationResulterrorDiv').style.display = 'none';

        if (document.querySelector('#add-create_task-tab-error')) {
          document.querySelector('#add-create_task-tab-error').classList.remove('active');
        }
        if (document.querySelector('#add-modify_record-tab-error')) {
          document.querySelector('#add-modify_record-tab-error').classList.remove('active');
        }
        if (document.querySelector('#add-send_email-tab-error')) {
          document.querySelector('#add-send_email-tab-error').classList.remove('active');
        }
        if (document.querySelector('#add-create_record-tab-error')) {
          document.querySelector('#add-create_record-tab-error').classList.remove('active');
        }

        var task = document.querySelector('#create_tasksuccess');
        var modify = document.querySelector('#modify_recordsuccess');
        var create = document.querySelector('#create_recordsuccess');
        var email = document.querySelector('#send_emailsuccess');

        if (actionType == 'send_email') {

          task ? task.style.display = 'none' : null;
          modify ? modify.style.display = 'none' : null;
          create ? create.style.display = 'none' : null;
          email ? email.style.display = 'block' : null;

        } else if (actionType == 'create_task') {

          email ? email.style.display = 'none' : null;
          modify ? modify.style.display = 'none' : null;
          create ? create.style.display = 'none' : null;
          task ? task.style.display = 'block' : null;

        } else if (actionType == 'modify_record') {

          task ? task.style.display = 'none' : null;
          email ? email.style.display = 'none' : null;
          create ? create.style.display = 'none' : null;
          modify ? modify.style.display = 'block' : null;

        } else if (actionType == 'create_record') {
          task ? task.style.display = 'none' : null;
          modify ? modify.style.display = 'none' : null;
          email ? email.style.display = 'none' : null;
          create ? create.style.display = 'block' : null;
        }


        if (document.querySelector('.' + whichSection).style.display != 'block') {
          document.querySelector('.' + whichSection).style.display = 'block';
        }

        document.querySelector('#' + actionType + state).style.display = 'active show';

      } else if (state == 'error') {

        document.querySelector('.simulationResultsuccessDiv').style.display = 'none';

        if (document.querySelector('#add-create_task-tab-success')) {
          document.querySelector('#add-create_task-tab-success').classList.remove('active');
        }
        if (document.querySelector('#add-modify_record-tab-success')) {
          document.querySelector('#add-modify_record-tab-success').classList.remove('active');
        }
        if (document.querySelector('#add-send_email-tab-success')) {
          document.querySelector('#add-send_email-tab-success').classList.remove('active');
        }
        if (document.querySelector('#add-create_record-tab-success')) {
          document.querySelector('#add-create_record-tab-success').classList.remove('active');
        }

        var task = document.querySelector('#create_taskerror');
        var modify = document.querySelector('#modify_recorderror');
        var create = document.querySelector('#create_recorderror');
        var email = document.querySelector('#send_emailerror');

        if (actionType == 'send_email') {

          task ? task.style.display = 'none' : null;
          modify ? modify.style.display = 'none' : null;
          create ? create.style.display = 'none' : null;
          email ? email.style.display = 'block' : null;

        } else if (actionType == 'create_task') {

          email ? email.style.display = 'none' : null;
          modify ? modify.style.display = 'none' : null;
          create ? create.style.display = 'none' : null;
          task ? task.style.display = 'block' : null;

        } else if (actionType == 'modify_record') {

          task ? task.style.display = 'none' : null;
          email ? email.style.display = 'none' : null;
          create ? create.style.display = 'none' : null;
          modify ? modify.style.display = 'block' : null;

        } else if (actionType == 'create_record') {
          task ? task.style.display = 'none' : null;
          modify ? modify.style.display = 'none' : null;
          email ? email.style.display = 'none' : null;
          create ? create.style.display = 'block' : null;
        }

        if (document.querySelector('.' + whichSection).style.display != 'block') {
          document.querySelector('.' + whichSection).style.display = 'block';
        }

        document.querySelector('#' + actionType + state).style.display = 'active show';
      }
    },
    checkHasDataSuccess(result, actiontype) {
      if (actiontype == 'create_record') {
        if (result.create_record.success.length > 0) {
          return true;
        }
        return false;
      }
      if (actiontype == 'send_email') {
        if (result.send_email.success.length > 0) {
          return true;
        }
        return false;
      }
      if (actiontype == 'create_task') {
        if (result.create_task.success.length > 0) {
          return true;
        }
        return false;
      }
      if (actiontype == 'modify_record') {
        if (result.modify_record.success.length > 0) {
          return true;
        }
        return false;
      }
    },
    checkHasDataError(result, actiontype) {
      if (actiontype == 'create_record') {
        if (result.create_record.error.length > 0) {
          return true;
        }
        return false;
      }
      if (actiontype == 'send_email') {
        if (result.send_email.error.length > 0) {
          return true;
        }
        return false;
      }
      if (actiontype == 'create_task') {
        if (result.create_task.error.length > 0) {
          return true;
        }
        return false;
      }
      if (actiontype == 'modify_record') {
        if (result.modify_record.error.length > 0) {
          return true;
        }
        return false;
      }
    },
    simulationResultHasSuccess() {
      if (
          (this.simulationResult.create_record != undefined && this.simulationResult.create_record.success.length != 0) ||
          (this.simulationResult.create_task != undefined && this.simulationResult.create_task.success.length != 0) ||
          (this.simulationResult.modify_record != undefined && this.simulationResult.modify_record.success.length != 0) ||
          (this.simulationResult.send_email != undefined && this.simulationResult.send_email.success.length != 0)
      ) {
        return true;
      }
      return false;
    },
    simulationResultHasError() {

      if (
          (this.simulationResult.create_record != undefined && this.simulationResult.create_record.error.length != 0) ||
          (this.simulationResult.create_task != undefined && this.simulationResult.create_task.error.length != 0) ||
          (this.simulationResult.modify_record != undefined && this.simulationResult.modify_record.error.length != 0) ||
          (this.simulationResult.send_email != undefined && this.simulationResult.send_email.error.length != 0)
      ) {
        return true;
      }
      return false;
    },
    createObjectForSimulationForm(SelectedTableFields, simulationFormObject) {
      for (var field in SelectedTableFields) {

        if (SelectedTableFields[field].name == 'created_by' || SelectedTableFields[field].name == 'modified_by') {
          simulationFormObject.push({
            'name': SelectedTableFields[field].name,
            'value': this.SelectedTable.user_name[0].id,
          });
        } else if (SelectedTableFields[field].name == 'assigned_to') {
          simulationFormObject.push({
            'name': SelectedTableFields[field].name,
            'value': this.SelectedTable.user_name[0].id,
          });
        } else if (SelectedTableFields[field].field_type == 'multiselect'
            || SelectedTableFields[field].field_type == 'multipleselect') {
          simulationFormObject.push({
            'name': SelectedTableFields[field].name,
            'value': [],
          });
        } else if (SelectedTableFields[field].field_type == 'checkbox') {
          simulationFormObject.push({
            'name': SelectedTableFields[field].name,
            'value': 'off',
          });
        } else {
          simulationFormObject.push({
            'name': SelectedTableFields[field].name,
            'value': null,
          });
        }
      }
    },
    simulationFormDataEvent(data) {
      let _index = this.simulationFormData.findIndex(x => x.name == data.name);

      if (_index > -1) {
        this.simulationFormData[_index].value = data.value;
      }

      // console.log(this.simulationFormData);
    },
    FormatSimulationCreateRecords(create_records) {
      let _create_records = {};

      for (let i = 0; i < create_records.length; i++) {
        if (_create_records[create_records[i]['record_insert_for_table']] == undefined) {
          _create_records[create_records[i]['record_insert_for_table']] = [];
        }

        let _length = _create_records[create_records[i]['record_insert_for_table']].length;
        _create_records[create_records[i]['record_insert_for_table']][_length] = create_records[i];
      }

      return _create_records;
    },
    DaysOfMonth() {
      for (var i = 1; i <= 31; i++) {
        this.days_of_month.push({
          'value': i
        });
      }
    },
    hasDisabled() {
      if (!this.cron_settings.cron_execution_start_date.value) {
        this.cron_settings.cron_execution_end_date.value = null;
        return true;
      }

      return false;
    },
    setMinDate(nonFormatedDate) {
      if (nonFormatedDate) {
        return moment(nonFormatedDate, this.setDynamicFormat()).format('YYYY-MM-DD');
      }
    },
    GetConditions() {

      console.log(this.selected_field_type);

      if (this.selected_field_type == 'number' || this.selected_field_type == 'formula' || this.selected_field_type == 'amount') {
        return this.conditionsfornumber;
      }

      return this.conditions;
    },
    ResetConditionBtnOccurenceArray() {
      this.addConditionBtnOccurence = [];
      this.RebulidAutomationQueryTree();
    },
    SetSubLevelValue(data) {
      this.subLevel = data;
    },
    UpdateConditionBtnOccurenceArray(data) {
      if (data.value == null) {
        this.addConditionBtnOccurence[data.group_id] = [];
      } else {
        this.addConditionBtnOccurence[data.group_id].push(data.value);
      }
    },
    hasQuery(level) {

      var thisLevelQuery = [];

      for (var i in this.RawQueryStructure) {
        if (this.RawQueryStructure[i].level == level && !this.RawQueryStructure[i].remove) {
          thisLevelQuery.push(this.RawQueryStructure[i].id);
        }
      }

      if (thisLevelQuery.length > 0) {
        return false;
      } else {
        return true;
      }
    },
    manipulateRawQueryStructure(operatortext = null, level = null, id = null) {

      for (let x in this.RawQueryStructure) {
        if (this.RawQueryStructure[x].id == id) {
          if (!operatortext) {
            this.RawQueryStructure[x].remove = true; // condtion remove
          } else {
            this.RawQueryStructure[x].operator = operatortext; // update operator
            this.RawQueryStructure[x].update = true;
          }
        }
      }

      this.RebulidAutomationQueryTree();
    },
    RebulidAutomationQueryTree() {
      this.newAutomation = [];
      this.newAutomation = JSON.parse(JSON.stringify(this.makeAutomationQuery(this.RawQueryStructure)));
      // remove the garbage queries
      // this.RemoveGarbageQuery(this.newAutomation.queries);
    },
    RemoveGarbageQuery(structureQuery) {
      if (structureQuery != undefined) {
        // console.log(structureQuery);
        for (let i = 0; i < structureQuery.length; i++) {
          if (structureQuery[i].fieldConcatValue != undefined && structureQuery[i].parent_group_id != 0) {
            structureQuery[i].queries = [];
          } else {
            this.RemoveGarbageQuery(structureQuery[i].queries);
          }
        }
      }
    },
    makeAutomationQuery(automationQueries) {
      let _queries = [];

      // sort the automation query
      automationQueries = _.orderBy(automationQueries, 'order', 'desc');

      // set up the first level query
      for (let i = 0; i < automationQueries.length; i++) {
        if (automationQueries[i].parent_group_id == 0) {
          if (automationQueries[i].queries == undefined) {
            automationQueries[i].queries = [];
          }

          // push the query in new index
          automationQueries[i].queries = (this.GetChildQueries(automationQueries, automationQueries[i].group_id));

          if (_queries[automationQueries[i].level] == undefined) {
            _queries[automationQueries[i].level] = [];
          }

          _queries[automationQueries[i].level].push(automationQueries[i]);
        }
      }

      return _queries;
    },
    GetChildQueries(automationQueries, group_id) {
      let _childQueries = [];

      for (let i = 0; i < automationQueries.length; i++) {
        if (automationQueries[i].parent_group_id == group_id) {
          if (automationQueries[i].queries == undefined) {
            automationQueries[i].queries = [];
          }

          automationQueries[i].queries = (this.GetChildQueries(automationQueries, automationQueries[i].group_id));
          _childQueries.push(automationQueries[i]);
        }
      }

      return _childQueries;
    },
    existingCompanies() {
      axios.post('/existing-companies').then(response => {
        this.companies = response.data;
      });
    },
    GetActionByLevel(actions, level) {

      if (actions) {
        let level_action = actions.filter((x) => x.level == level);
        return level_action;
      }
    },
    GetActionByLevelUnsaved(actions, level) {
      if (actions[level] != undefined) {
        return actions[level];
      }

    },
    getTableFields(table_id) {
      axios.post('/get-fields', {'table_id': table_id}).then(response => {
        this.fields = response.data;
      });
    },
    groupConditionFind(groupId, groupCondition) {
      for (var group_index in this.groupCondition) {
        if (this.groupCondition[group_index].group_id == groupId) {
          return this.groupCondition[group_index].condition;
        }
      }
    },
    groupConditionSelector(SelectedValue, groupId) {
      for (var group_index in this.groupCondition) {
        if (this.groupCondition[group_index].group_id == groupId) {
          this.groupCondition[group_index].condition = SelectedValue;
        }
      }
    },
    outside() {
      this.previousCondition();
      for (let div in this.dynamicDiv) {
        this.dynamicDiv[div].active = false;
      }

      for (let div in this.RawQueryStructure) {
        this.RawQueryStructure[div].modal = false;
      }

      this.GlobalQueryParentId = null;
      this.OrderId = 0;
      this.subLevel = 0;
      this.group = 0;

      for (let automation in this.automations) {
        for (let x in this.automations[automation]) {
          this.automations[automation][x].modal = false;
        }
      }
      this.oldRecordDropDownModal = false;
      this.selectedOrInputValue = null;
      this.check_not_empty = 0;
      this.having = 'is'; // reste having value
      this.whenQueryEdit = null; // push in this variable when edit the query again
      this.has_value = 0;
      this.reactive();
    },
    automationEditState(event, level, id) {

      for (let x in this.RawQueryStructure) {
        if (id == this.RawQueryStructure[x].id) {
          this.whenQueryEdit = this.RawQueryStructure[x];
          this.RawQueryStructure[x].modal = true;
          this.having = this.RawQueryStructure[x].having; // when edit set is,ends_with,start_with e.t.c
          if (this.RawQueryStructure[x].check_not_empty == 1) {
            this.savedInput = this.RawQueryStructure[x].value.toString();
            this.fieldConcatValue = this.table + '.' + this.RawQueryStructure[x].value.join(); // for fronted purpose e.g tablename.value
            this.selectedOrInputValue = this.RawQueryStructure[x].value;
          } else {
            this.selectedOrInputValue = this.RawQueryStructure[x].value;
            this.fieldConcatValue = this.table + '.' + this.RawQueryStructure[x].value.join(); // for fronted purpose tablename.value
            this.savedInput = null;
          }
          this.has_value = this.RawQueryStructure[x].has_value;
        } else {
          this.RawQueryStructure[x].modal = false;
        }
      }

      // / when modal open with saved data state

      if (this.whenQueryEdit) {
        axios.post('/get-fields-value', {
          table: this.db_exactTable_name,
          field: this.whenQueryEdit.tableField,
          timeZone: this.timeZone
        }).then(response => {
          this.tableWithValues = response.data;
          this.fieldTranslationsLabel = response.data.field_label;
        }); // get the value of the field

        if (this.whenQueryEdit.check_not_empty == 0) {
          this.accrodionState = 3;
        } else {
          this.accrodionState = 2;
        }
        this.tableField = this.whenQueryEdit.tableField;
        this.tableField_id = this.whenQueryEdit.column_primary;
        this.selected_text_seen = false;
        this.moreCondition = true;
        this.selected_accordion_seen = false;
      }

      // this.openAutomationModal(id);
      this.reactive();
    },

    openAutomationModal(level) {
      for (let div in this.dynamicDiv) {
        if (div == level) {
          this.dynamicDiv[level].active = true;
        } else {
          this.dynamicDiv[div].active = false;
        }
      }
      this.reactive();
    },
    whichWhenChange(event, variable) {
      if (variable == 'when') {
        this.when_should = event.target.value;
        $('.when-selectbox').removeClass('select-box-danger');
      } else {

        this.which_record = event.target.value;
        for (var table in this.tables) {
          if (this.tables[table].id == event.target.value) {
            this.table = this.tables[table].label;
            this.db_exactTable_name = this.tables[table].plural;
            this.getTableFields(this.which_record);
            this.getTemplates();
          }
        }
        $('.which-selectbox').removeClass('select-box-danger');
        // get the values of the present table
        axios.post('/selected-table', {'table_id': this.which_record}).then(response => {
          if (response.data.success) {
            this.SelectedTable = response.data.result;
            this.SelectedTableExcludedColumnListEmail = response.data.result.SelectedTableExcludedColumnListEmail;
            this.SelectedTableExcludedColumnListReationship = response.data.result.SelectedTableExcludedColumnListReationship;
            this.simulationFormData = [];
            this.createObjectForSimulationForm(this.SelectedTable.fields, this.simulationFormData);
          }
        });
        $('#test-modal').find('form').trigger('reset');
      }

      for (var query in this.RawQueryStructure) {
        this.RemoveQueryGroupIds.push(this.RawQueryStructure[query].group_id);
      }

      for (var action in this.saved_actions) {
        this.actions_to_be_removed_ids.push(this.saved_actions[action].id);
      }

      this.action_details = [];
      this.RawQueryStructure = [];

      if (this.dynamicDiv.length > 0) {
        for (var i = 0; i < this.dynamicDiv.length; i++) {
          this.removeAutomation(i);
        }
      } else {
        this.removeAutomation(0);
      }

      this.previousCondition();
    },
    saveCondition(automation_id, event = null) {

      let _error = this.validateForm();

      // for execute now type automation
      var _flag = false;
      if (event == 'execute') {
        _flag = true;
      }

      if (!_error && this.RawQueryStructure.length > 0) {

        this.loading = true;

        axios.post('/condition-save', {
          description: this.description,
          execution_type_id: this.when_should,
          type: this.type,
          table_id: this.which_record,
          conditions: this.automations,
          RawQueryStructure: this.RawQueryStructure,
          groupCondition: this.groupCondition,
          automation_id: automation_id,
          flag: _flag,
          action_details: this.action_details,
          saved_actions: this.saved_actions,
          delete_actions: this.actions_to_be_removed_ids,
          cron: this.cron_settings,
          removeQueryList: this.RemoveQuriesList,
          removeQueryGroup: this.RemoveQueryGroupIds,
          timeZone: this.timeZone,
        }).then(response => {
          if (!automation_id) {
            this.automations = [];
            this.lastSavedLevel = [];
            this.dynamicDiv = [{
              active: false
            }];
            this.resetCronModal();
            window.location.href = response.data.url;

          } else {
            this.propQueries = response.data.__queries;
            location.reload();
          }

          this.loading = false;

        }).catch(error => {
          this.loading = false;
          location.reload();
        });
      }
    },
    validateForm() {
      let me = this;
      let _error = false;
      let _msg = [];

      if (!this.when_should) {
        $('.when-selectbox').addClass('select-box-danger');
        _error = true;
      }

      if (!this.which_record) {
        $('.which-selectbox').addClass('select-box-danger');
        _error = true;
      }

      this.dynamicDiv.forEach(function (item, _level) {
        // check the automations

        if (me.RawQueryStructure[_level] == undefined) {
          _msg.push("<p><strong>Error!</strong> Please selet a criteria for condition " + (_level + 1) + "</p>");
          _error = true;
        } else if (me.RawQueryStructure[_level].length == 0) {
          _msg.push("<p><strong>Error!</strong> Please selet a criteria for condition " + (_level + 1) + "</p>");
          _error = true;
        }

        // check the actions
        if (me.saved_actions == undefined && me.action_details[_level] == undefined) {
          _msg.push("<p><strong>Error!</strong> Please selet an action for condition " + (_level + 1) + "</p>");
          _error = true;
        } else {

          if (me.saved_actions != undefined) {
            if (me.saved_actions[_level] == undefined) {
              if (me.action_details[_level] == undefined) {
                _msg.push("<p><strong>Error!</strong> Please selet an action for condition " + (_level + 1) + "</p>");
                _error = true;
              } else {
                if (me.action_details[_level].length == 0) {
                  _msg.push("<p><strong>Error!</strong> Please selet an action for condition " + (_level + 1) + "</p>");
                  _error = true;
                }
              }
            }
          }
        }
      });

      if (_msg.length > 0) {
        for (let index = 0; index < _msg.length; index++) {
          const error_msg = _msg[index];
          // this.$awn.alert(error_msg);
          toastr.error(error_msg);
        }
        // $('.automation-error').html(_msg);
        // $('.automation-error').show();
      } else {
        $('.automation-error').html();
        $('.automation-error').hide();
      }

      return _error;
    },
    shouldBeChecked() {
      if (!this.when_should) {
        $('.when-selectbox').addClass('select-box-danger');
      }
      if (!this.which_record) {
        $('.which-selectbox').addClass('select-box-danger');
      }
    },
    getCondition(condition, value) {
      $('.set-selected-condition').text(condition).css({
        color: '#e89a52'
      });
      this.$emit('getcondition', value);
    },
    searchSubmit(event) {
      let keyword = event.target.value.toLowerCase();
      $("#filterSearch *").filter(function () {
        $(this).toggle($(this).text().toLowerCase().indexOf(keyword) > -1);
      });
    },
    listenerChild(selected_value = null, selectionObj = null, level = null) {

      this.fieldConcatValue = null;
      let havingValue = null;
      // console.log(selectionObj);

      if (selected_value != 'selection') { // If 'selection' string come from child component then hide current one e.g table field

        this.selected_field_type = selected_value.field_type;

        axios.post('/get-fields-value', {
          table: this.db_exactTable_name,
          field: selected_value.field_name,
          field_id: selected_value.id,
          timeZone: this.timeZone
        }).then(response => {
          this.tableWithValues = response.data.field_value;
          this.fieldTranslationsLabel = selected_value.record == 'old' ? 'Old Values.' + response.data.field_label : response.data.field_label;
          this.conditionTranslationsLabel = response.data.field_label;
          this.conditionRecordType = selected_value.record != undefined ? 'old' : 'new';
        }); // get the value of the field

        this.accrodionState = 3;
        this.tableField = selected_value.field_name;
        this.tableField_id = selected_value.id;
        this.selected_text_seen = false;
        this.moreCondition = true;
        this.selected_accordion_seen = false;

      } else {

        if (!selectionObj) {
          this.accrodionState = 2;
        } else {
          for (var key in selectionObj) {
            for (let value in selectionObj[key]) {
              if (selectionObj[key][value].fieldName == 'Having Value') {
                havingValue = selectionObj[key][value].fieldName;
              }
            }
            if (!havingValue) {
              if (selectionObj[key].length > 0) {
                this.selectedOrInputValue = selectionObj[key]; // DB values column data
                this.has_value = 0;
                let values = '';
                for (var fieldValue in selectionObj[key]) {
                  values += selectionObj[key][fieldValue].fieldName + ',';
                }
                var lastIndex = values.lastIndexOf(',');
                values = values.substring(0, lastIndex);
                this.fieldConcatValue = this.table + '.' + values; // for fronted purpose e.g tablename.value
              }
            } else {
              this.selectedOrInputValue = [havingValue];
              this.fieldConcatValue = this.table + '.' + havingValue; // for fronted purpose e.g tablename.havingvalue
            }
          }

          if (havingValue == 'Having Value') {
            this.check_not_empty = 0;
            this.has_value = 1;
            this.apply(level);
          }
        }
      }
    },
    previousCondition() {
      this.accrodionState = 1;
      this.moreCondition = false;
      this.selected_accordion_seen = true;
      this.selected_text_seen = true;
    },
    back() {
      this.moreCondition = true;
    },
    operatorCondition(operatortext, level, id) {

      this.renderComponent = false;
      this.manipulateRawQueryStructure(operatortext, level, id);
      this.renderComponent = true;
    },

    showAddConditionBtn(automation, index, queries) {
      let group_id = automation.group;
      let search_group_id = null;

      // search parent id
      if (group_id != null) {
        search_group_id = automation.group;
      }

      // handle the null parent id
      if (automation.group == null) {
        if (this.addConditionBtnOccurence[0] == undefined) {
          this.addConditionBtnOccurence[0] = [];
        }

        group_id = 0;
      }

      // handle the undefined exception
      if (this.addConditionBtnOccurence[group_id] == undefined) {
        this.addConditionBtnOccurence[group_id] = [];
      }
      let _index = this.addConditionBtnOccurence[group_id].indexOf(automation.id);


      // check whether the id exists or not
      if (_index == -1) {
        this.addConditionBtnOccurence[group_id].push(automation.id);
      }

      var count = queries.reduce(function (n, query) {
        return n + (query.group == search_group_id);
      }, 0);

      // check the count
      if (this.addConditionBtnOccurence[group_id].length == count) {
        return true;
      } else {
        return false;
      }
    },
    ApplyChildFunction(data) {
      this.apply(data.level, data);
    },
    apply(level = null, data = null) {

      this.OrderId = this.OrderId + 1; // global

      // console.log(data);

      // need to global order id where user click and save
      // new query because new add form modal not in query loop so

      let group_id = new Date().getTime();

      if (!data) {
        if (this.fieldConcatValue == undefined || !this.fieldConcatValue) {
          alert('Please select some table value');
          return;
        }
      } else {
        if (data.fieldConcatValue == undefined || !data.fieldConcatValue) {
          alert('Please select some table value');
          return;
        }
      }

      // create at time
      let _date = new Date();
      _date.setMilliseconds(0);
      let time_stamp = _date.getTime() / 1000;

      if (!data) {
        this.RawQueryStructure.push({
          level: level,
          id: time_stamp,
          parentId: null,
          subLevel: this.subLevel,
          having: this.having,
          tableField: this.tableField,
          column_primary: this.tableField_id,
          fieldConcatValue: this.fieldConcatValue,
          operator: 'AND',
          modal: false,
          check_not_empty: this.check_not_empty,
          value: this.selectedOrInputValue,
          remove: false,
          update: true,
          has_value: this.has_value,
          isGroup: false,
          order: this.OrderId - 1,
          parent_group_id: 0,
          group_id: group_id,
          fieldTranslationsLabel: this.conditionTranslationsLabel,
          conditionRecordType: this.conditionRecordType,
        });

        this.pushGroupCondtion(group_id, 0);

        this.RawQueryStructure = _.orderBy(this.RawQueryStructure, 'order', 'desc');

        // get the index of the current order value
        let _index = this.RawQueryStructure.findIndex(x => x.order == this.OrderId - 1);

        if (_index > -1) {
          // check for the child components
          let _item = this.RawQueryStructure[_index];
          // increment the consecutive element order
          for (let i = (_index + 1); i < this.RawQueryStructure.length; i++) {
            this.RawQueryStructure[i].order = this.OrderId++;
          }
        }
      } else if (data != null && data.QueryEditState) {

        for (let x in this.RawQueryStructure) {
          if (this.RawQueryStructure[x].id == data.query_id) {
            this.RawQueryStructure[x].having = data.having;
            this.RawQueryStructure[x].tableField = data.tableField;
            this.RawQueryStructure[x].column_primary = data.tableField_id;
            this.RawQueryStructure[x].fieldConcatValue = data.fieldConcatValue;
            this.RawQueryStructure[x].modal = false;
            this.RawQueryStructure[x].check_not_empty = data.check_not_empty;
            this.RawQueryStructure[x].value = data.selectedOrInputValue;
            this.RawQueryStructure[x].update = true;
            this.RawQueryStructure[x].has_value = data.has_value;
            this.RawQueryStructure[x].fieldTranslationsLabel = data.fieldTranslationsLabel;
            this.RawQueryStructure[x].conditionRecordType = data.conditionRecordType;
          }
        }
      } else {
        let _order = data.OrderId;
        this.RawQueryStructure = _.orderBy(this.RawQueryStructure, 'order', 'asc');

        // get the index of the current order value
        let _index = this.RawQueryStructure.findIndex(x => x.order == _order);

        if (_index > -1) {
          // check for the child components
          let _item = this.RawQueryStructure[_index];
          _order = _order + 1;

          // increment the consecutive element order
          for (let i = (_index); i < this.RawQueryStructure.length; i++) {
            this.RawQueryStructure[i].order = _order++;
          }
        }

        if (data.advanced) {
          this.RawQueryStructure.push({
            level: level,
            id: time_stamp,
            parentId: data.GlobalQueryParentId,
            subLevel: data.subLevel,
            having: data.having,
            tableField: data.tableField,
            column_primary: data.tableField_id,
            fieldConcatValue: data.fieldConcatValue,
            operator: 'AND',
            modal: false,
            check_not_empty: data.check_not_empty,
            value: data.selectedOrInputValue,
            remove: false,
            update: true,
            has_value: data.has_value,
            isGroup: false,
            order: data.OrderId - 1,
            group_id: group_id,
            parent_group_id: data.parent_group_id,
            fieldTranslationsLabel: data.fieldTranslationsLabel,
            conditionRecordType: data.conditionRecordType,
          });

          this.pushGroupCondtion(group_id, data.parent_group_id);

        } else {
          this.RawQueryStructure.push({
            level: level,
            id: time_stamp,
            parentId: data.GlobalQueryParentId,
            subLevel: data.subLevel,
            having: data.having,
            tableField: data.tableField,
            column_primary: data.tableField_id,
            fieldConcatValue: data.fieldConcatValue,
            operator: 'AND',
            modal: false,
            check_not_empty: data.check_not_empty,
            value: data.selectedOrInputValue,
            remove: false,
            update: true,
            has_value: data.has_value,
            isGroup: false,
            order: data.OrderId,
            group_id: data.group_id,
            parent_group_id: data.parent_group_id,
            fieldTranslationsLabel: data.fieldTranslationsLabel,
            conditionRecordType: data.conditionRecordType,
          });
        }
      }

      this.RebulidAutomationQueryTree();
      this.outside();
    },
    emitconditionGroup(data) {

      let subLevel = 0;

      if (isNaN(data.subLevel)) {
        subLevel = 0;
      } else {
        subLevel = data.subLevel;
      }

      let _order = data.automation.order;
      let group_id = new Date().getTime();


      let _date = new Date();
      _date.setMilliseconds(0);
      let time_stamp = _date.getTime() / 1000;

      if (isNaN(_order)) {
        this.RawQueryStructure.push({
          level: data.level,
          subLevel: subLevel,
          id: time_stamp,
          parentId: data.automation.id,
          operator: 'AND',
          isGroup: true,
          update: true,
          remove: false,
          modal: false,
          order: 0,
          parent_group_id: data.automation.group_id,
          group_id: group_id,
        });
      } else {
        this.RawQueryStructure.push({
          level: data.level,
          subLevel: subLevel,
          id: time_stamp,
          parentId: data.automation.id,
          operator: 'AND',
          isGroup: true,
          update: true,
          remove: false,
          modal: false,
          order: _order + 1,
          parent_group_id: data.automation.group_id,
          group_id: group_id,
        });
      }

      this.pushGroupCondtion(group_id, data.automation.group_id);
    },
    pushGroupCondtion(group_id, parent_group_id) {

      this.groupCondition.push({
        group_id: group_id,
        parent_group_id: parent_group_id,
        condition: 'AND'
      });

      // console.log(this.groupCondition);

      this.RebulidAutomationQueryTree();
    },
    removeDiv(level, id) {
      let value = null;
      this.manipulateRawQueryStructure(value, level, id);
      this.reactive();
    },
    removeQuery(id) {
      for (let x in this.RawQueryStructure) {
        if (id == this.RawQueryStructure[x].id) {
          this.RemoveQuriesList.push(id);
          this.RawQueryStructure.splice(x, 1);
        }
      }
      this.RebulidAutomationQueryTree();
    },
    removeQueryGroup(groupId) {
      // prepare the list of the id occured
      for (let i = 0; i < this.RawQueryStructure.length; i++) {
        if (this.RawQueryStructure[i].group_id == groupId) {
          this.RemoveQueryGroupIds.push(groupId);
        }
      }

      this.removeChildQueries(groupId);

      // delete the queries from raw query structure
      for (let j = 0; j < this.RemoveQueryGroupIds.length; j++) {
        // get the index of the query
        let _index = this.RawQueryStructure.findIndex(x => x.group_id == this.RemoveQueryGroupIds[j]);

        if (_index > -1) {
          this.RawQueryStructure.splice(_index, 1);
        }
      }

      this.RebulidAutomationQueryTree();
    },
    removeChildQueries(parent_group_id) {
      let _index = this.RawQueryStructure.findIndex(x => x.parent_group_id == parent_group_id);

      if (_index > -1) {
        // prepare the list of the id occured
        for (let i = 0; i < this.RawQueryStructure.length; i++) {
          if (this.RawQueryStructure[i].parent_group_id == parent_group_id) {
            let _group_id = this.RawQueryStructure[i].group_id;
            this.RemoveQueryGroupIds.push(_group_id);

            this.removeChildQueries(_group_id);
          }
        }

      }
    },
    dynamicDivCreator() {
      this.dynamicDiv.push({
        active: false
      });
    },
    updateQueriesLevel(_level) {
      let _indexes = [];

      for (var i = 0; i < this.RawQueryStructure.length; i++) {
        // delete the items at _level
        if (this.RawQueryStructure[i].level == _level) {
          _indexes.push(i);
        }

        if (this.RawQueryStructure[i].level > _level) {
          this.RawQueryStructure[i].level = this.RawQueryStructure[i].level - 1;
        }
      }

      for (let j = 0; j < +_indexes.length; j++) {
        this.RawQueryStructure.splice(_indexes[j], 1);
      }
    },
    removeAutomation(level) {

      if (level > 0) {
        for (let x in this.dynamicDiv) {
          if (x == level) {
            this.dynamicDiv.splice(level, 1);
          }
        }
      }

      this.updateQueriesLevel(level);
      let unsaved_actions = this.action_details;

      this.mapLevelActionAfterLevelRemoved(level);
      this.reactive();
    },
    mapLevelActionAfterLevelRemoved(level) {
      let me = this;

      /** rearrage the values for removed index **/

          // rearrange the levels(or indexes)
      let _remove_saved_action_ids = [];
      $.each(this.saved_actions, function (index, value) {
        if (value != undefined) {
          if (value.level > level) {
            me.saved_actions[index].level = value.level - 1;
          } else if (value.level == level) {
            _remove_saved_action_ids.push(index);
          }
        }
      });

      /** Sort the array in desc to start pop from end of an array */
      _remove_saved_action_ids.sort(function (a, b) {
        return b - a
      });

      // remove the ids
      $.each(_remove_saved_action_ids, function (index, value) {
        if (me.saved_actions[value] != undefined) {
          me.saved_actions.splice(value, 1);
        }
      });


      // get the total levels
      if (this.action_details.length != 0) {
        let _temp_max_actions_level = Object.keys(this.action_details).reduce((a, b) => this.action_details[a] > this.action_details[b] ? a : b);
        this.action_details.splice(level, 1);
      }
    },
    openModal(id, _level) {
      // set the level
      this.action_for_level = _level;

      if (this.which_record && this.when_should) {
        $('#add-action-modal').modal('show');
        $('[href="' + id + '"]').tab('show');
      } else if (!this.which_record || !this.when_should) {
        this.shouldBeChecked();
      }

      let editorElem = document.getElementsByClassName('tox-tinymce');
      for (let i = 0; i < editorElem.length; i++) {
        editorElem[i].style.height = '85%';
      }
    },
    setSimulationTab(simulationResult) {
      let tab_elements = document.getElementsByClassName('test-modal-tabs');

      for (let i = 0; i < tab_elements.length; i++) {
        tab_elements[i].classList.remove('active');
      }

      let tab_panel_elements = document.getElementsByClassName('test-modal-tabs-panel');

      for (let i = 0; i < tab_elements.length; i++) {
        tab_panel_elements[i].classList.remove('show');
        tab_panel_elements[i].classList.remove('active');
      }

      if (simulationResult.modify_record != undefined && simulationResult.modify_record.length != 0) {
        this.executeNowSimulationActiveTab = 'modify_record';
      } else if (simulationResult.create_task != undefined && simulationResult.create_task.length != 0) {
        this.executeNowSimulationActiveTab = 'create_task';
      } else if (simulationResult.send_email != undefined && simulationResult.send_email.length != 0) {
        this.executeNowSimulationActiveTab = 'send_email';
      } else if (simulationResult.create_record != undefined && simulationResult.create_record.length != 0) {
        this.executeNowSimulationActiveTab = 'create_record';
      }
    },
    setSimulationTab_1(simulationResult) {
      if (simulationResult.modify_record != undefined && simulationResult.modify_record.length != 0) {
        this.executeNowSimulationActiveTab = 'modify_record';
      } else if (simulationResult.create_task != undefined && simulationResult.create_task.length != 0) {
        this.executeNowSimulationActiveTab = 'create_task';
      } else if (simulationResult.send_email != undefined && simulationResult.send_email.length != 0) {
        this.executeNowSimulationActiveTab = 'send_email';
      } else if (simulationResult.create_record != undefined && simulationResult.create_record.length != 0) {
        this.executeNowSimulationActiveTab = 'create_record';
      }
    },
    checkHasSimulation() {
      if (this.simulationResult.create_record != undefined
          && this.simulationResult.modify_record != undefined
          && this.simulationResult.create_task != undefined
          && this.simulationResult.send_email != undefined) {

        // set the simulation tab

        return true;
      }
    },
    openTestModal(record_id = null, formData = null, OldRecord = null, formstate = null) {

      if (this.which_record != null && this.when_should != null) {
        if (this.when_should == 1 || this.when_should == 2 || record_id || this.when_should == 6) {
          let _error = this.validateForm();
          if (!_error) {

            //   console.log(OldRecord);return;

            this.loading = true;
            axios.post('/query-simulation', {
              RawQueryStructure: this.RawQueryStructure,
              table_id: this.which_record,
              groupCondition: this.groupCondition,
              action_details: this.action_details ? this.action_details : [],
              saved_actions: this.saved_actions ? this.saved_actions : [],
              record_id: record_id,
              OldRecord: OldRecord,
              formstate: formstate,
              timeZone: this.timeZone,
              handler: this.when_should
            })
                .then(response => {
                  this.simulationResult = response.data.original;
                  let form_created_record = {};
                  let fields_values = this.additionalDataOfFields(formData);

                  form_created_record['record_insert_for_table'] = this.SelectedTable.label;
                  form_created_record['new'] = fields_values;
                  form_created_record['old'] = [];

                  if (this.when_should == 4) {

                    if (this.showTestOperationDiv) {
                      this.simulationResult.modify_record = {
                        'success': [],
                        'error': []
                      };
                      this.simulationResult.create_record.success.push(form_created_record);
                    } else {

                      this.simulationResult.modify_record = {
                        'success': [],
                        'error': []
                      };
                      this.simulationResult.create_record = {
                        'success': [],
                        'error': []
                      };
                      this.simulationResult.send_email = {
                        'success': [],
                        'error': []
                      };
                      this.simulationResult.create_task = {
                        'success': [],
                        'error': []
                      };
                      let Records = this.getFromModifyRecord(formData);

                      this.simulationResult.modify_record.success.push({
                        'new': Records.newRecord,
                        'old': Records.OldRecord
                      });
                    }
                  } else if (this.when_should == 5) {
                    if (this.showTestOperationDiv) {
                      this.simulationResult.modify_record = {
                        'success': [],
                        'error': []
                      };
                      this.simulationResult.create_record = {
                        'success': [],
                        'error': []
                      };
                      this.simulationResult.send_email = {
                        'success': [],
                        'error': []
                      };
                      this.simulationResult.create_task = {
                        'success': [],
                        'error': []
                      };
                      this.simulationResult.create_record.success.push(form_created_record);
                    } else {
                      let _modify_backend = null;
                      let _old_backend = null;
                      if (this.simulationResult.modify_record.success.length > 0) {
                        _modify_backend = this.simulationResult.modify_record.success[0].new;
                        _old_backend = this.simulationResult.modify_record.success[0].old;

                        for (let x in this.simulationResult.modify_record.success) {
                          if (x != 0) {
                            let newRecord = this.simulationResult.modify_record.success[x].new;
                            let oldRecord = this.simulationResult.modify_record.success[x].old;

                            for (let _element in newRecord) {
                              if (newRecord[_element] != oldRecord[_element]) {
                                _modify_backend[_element] = newRecord[_element];
                              }
                            }
                          }
                        }
                        if (_modify_backend.hasOwnProperty('id')) {
                          delete _modify_backend['id'];
                        }
                      }


                      this.simulationResult.modify_record = {
                        'success': [],
                        'error': []
                      };
                      let Records = this.getFromModifyRecord(formData);

                      if (Records.IsAnythingUpdate) {
                        this.simulationResult.modify_record.error.push({
                          'new': Records.newRecord,
                          'old': Records.OldRecord
                        });

                        if (this.simulationResult.create_record.success.length > 0) {
                          this.simulationResult.create_record.error = this.simulationResult.create_record.success;
                          this.simulationResult.create_record.success = [];

                        }
                        if (this.simulationResult.send_email.success.length > 0) {
                          this.simulationResult.send_email.error = this.simulationResult.send_email.success;
                          this.simulationResult.send_email.success = [];

                        }
                        if (this.simulationResult.create_task.success.length > 0) {
                          this.simulationResult.create_task.error = this.simulationResult.create_task.success;
                          this.simulationResult.create_task.success = [];
                        }

                      } else {
                        this.simulationResult.modify_record.success.push({
                          'new': _modify_backend ? _modify_backend : Records.newRecord,
                          'old': _old_backend ? _old_backend : Records.OldRecord
                        });
                      }
                    }
                  } else if (this.when_should == 3) {
                    if (this.showTestOperationDiv) {
                      this.simulationResult.modify_record = {
                        'success': [],
                        'error': []
                      };
                      this.simulationResult.create_record.success.push(form_created_record);
                    } else {

                      let _modify_backend = null;
                      let _old_backend = null;
                      if (this.simulationResult.modify_record.success.length > 0) {
                        _modify_backend = this.simulationResult.modify_record.success[0].new;
                        _old_backend = this.simulationResult.modify_record.success[0].old;

                        for (let x in this.simulationResult.modify_record.success) {
                          if (x != 0) {
                            let newRecord = this.simulationResult.modify_record.success[x].new;
                            let oldRecord = this.simulationResult.modify_record.success[x].old;

                            for (let _element in newRecord) {
                              if (newRecord[_element] != oldRecord[_element]) {
                                _modify_backend[_element] = newRecord[_element];
                              }
                            }
                          }
                        }
                        if (_modify_backend.hasOwnProperty('id')) {
                          delete _modify_backend['id'];
                        }
                      }

                      this.simulationResult.modify_record = {
                        'success': [],
                        'error': []
                      };
                      let Records = this.getFromModifyRecord(formData);

                      this.simulationResult.modify_record.success.push({
                        'new': _modify_backend ? _modify_backend : Records.newRecord,
                        'old': _old_backend ? _old_backend : Records.OldRecord
                      });
                    }
                  }

                  setTimeout(() => this.loading = false, 2000);
                  setTimeout(() => $('#test-result-modal').modal('show'), 2000);

                  if (this.CheckNoSimulationReturn()) {
                    this.noSimulationResult = true;
                  } else {
                    this.noSimulationResult = false;
                  }

                }).catch(error => {
              console.log(error);
              $('#test-result-modal').modal('hide');
              this.loading = false;
              this.noSimulationResult = true;
            });
          }
        } else {
          $('#test-modal').modal('toggle');
        }
      }
      if (!this.which_record || !this.when_should) {
        this.shouldBeChecked();
      }
    },
    getFromModifyRecord(formData) {

      let newRecord = {};
      let OldRecord = {};

      let IsAnythingUpdate = 1;
      let fields = this.SelectedTable.fields;

      for (let y in this.SelectedOldRecord) {

        let _index = formData.findIndex(x => x.name == y);
        let field_index = fields.findIndex(field => field.name == y);

        if (_index > -1) {

          if (y == 'assigned_to') {
            /* new record map assign user start*/
            newRecord[fields[field_index].label] = this.getRelatedValue(formData[_index].value);
            /* old record map assign user */
            OldRecord[fields[field_index].label] = this.getRelatedValue(this.SelectedOldRecord[y]);
          } else if (y == 'multi_assigned_to') {
            if (formData[_index].value !== null) {
              const value = Array.isArray(formData[_index].value) ? formData[_index].value : JSON.parse(formData[_index].value);
              newRecord[fields[field_index].label] = value.map(user => user.name).join(', ');
              OldRecord[fields[field_index].label] = value.map(user => user.name).join(', ');
            }
          } else if (y == 'visibility') {
            newRecord[fields[field_index].label] = formData[_index].value == 0 ? 'Private' : 'Everyone';
            OldRecord[fields[field_index].label] = this.SelectedOldRecord[y] == 0 ? 'Private' : 'Everyone';
          } else if (y == 'multi_selection') {
            newRecord[fields[field_index].label] = formData[_index].value.length > 0 ? formData[_index].value : null;

            if (this.SelectedOldRecord[y]) {
              OldRecord[fields[field_index].label] = this.SelectedOldRecord[y].length > 0 ? this.SelectedOldRecord[y] : null;
            }
          } else {

            if (fields[field_index].field_type == 'relationship') {

              let NewValue = formData[_index].value;
              let oldValue = this.SelectedOldRecord[y];

              newRecord[fields[field_index].label] = fields[field_index].related_fields[NewValue];
              OldRecord[fields[field_index].label] = fields[field_index].related_fields[oldValue];

            } else {
              newRecord[fields[field_index].label] = formData[_index].value;
              OldRecord[fields[field_index].label] = this.SelectedOldRecord[y];
            }
          }

          if (newRecord[fields[field_index].label] != OldRecord[fields[field_index].label]) {
            IsAnythingUpdate = 0;
          }
        }
      }

      return {
        'newRecord': newRecord,
        'OldRecord': OldRecord,
        'IsAnythingUpdate': IsAnythingUpdate,
      };
    },
    getRelatedValue(value) {
      let user = null;
      if (!value) {
        user = this.auth.first_name + ' ' + this.auth.last_name;
      } else {
        let _index = this.SelectedTable.user_name.findIndex(user => user.id == value);
        if (_index > -1) {
          user = this.SelectedTable.user_name[_index].name;
        }
      }

      return user;
    },
    additionalDataOfFields(formData) {
      let fields_values = {};

      for (let x in formData) {

        let _index = this.SelectedTable.fields.findIndex(field => field.name == formData[x].name);

        if (_index > -1) {

          let fieldLabel = this.SelectedTable.fields[_index].label;

          if (formData[x].name == 'assigned_to') {
            fields_values[fieldLabel] = this.getRelatedValue(formData[x].value);
          } else if (formData[x].name == 'visibility') {
            fields_values[fieldLabel] = formData[x].value == 0 ? 'Private' : 'Everyone';
          } else if (this.SelectedTable.fields[_index].field_type == 'relationship') {
            fields_values[fieldLabel] = this.SelectedTable.fields[_index].related_fields[formData[x].value];
          } else {
            fields_values[fieldLabel] = formData[x].value;
          }
        }
      }

      return fields_values;
    },
    openTestResultModal() {

      let fields = this.SelectedTable.fields;

      this.setSimulationTab_1(this.simulationResult);
      let modal_form_data = this.simulationFormData;

      if (!this.showTestOperationDiv) {
        if (!this.oldRecordInput) {
          alert('To test Update you should select the existing record then make changes to it.');
          return;
        }
      }

      let record_form_field = {};

      for (let field in fields) {
        let _index = modal_form_data.findIndex(x => x.name == fields[field].name);
        if (_index > -1) {
          record_form_field[modal_form_data[_index].name] = {
            'field_value': modal_form_data[_index].value,
            'field_details': fields[field]
          };
        }
      }

      console.log(this.showTestOperationDiv);

      if (this.showTestOperationDiv) {
        this.temporaryDataManipulationServeSide(record_form_field, modal_form_data, 'create');
      } else {
        this.temporaryDataManipulationServeSide(record_form_field, modal_form_data, 'update');
      }

      this.simulationResultState = true;
      this.simulationResult = [];

      $('#test-modal').modal('toggle');
    },
    getTableOldData() {
      this.oldRecordDropDownModal = true;
      if (this.oldRecordDropDownModal) {
        axios.post('/selected-table-rowdata', {
          'selectedtable': this.db_exactTable_name,
          'timeZone': this.timeZone
        })
            .then(response => {
              this.TableOldRecords = response.data;
            });
      }
    },
    temporaryDataManipulationServeSide(record_fields_and_value, formData, formstate) {

      let recordDetails = {};

      if (formstate == 'update') {
        recordDetails = {
          'OldRecord': this.SelectedOldRecord,
          'table': this.db_exactTable_name,
          'Newrecord': record_fields_and_value,
          'timeZone': this.timeZone,
        };
      } else {
        recordDetails = {
          'OldRecord': null, // when create
          'table': this.db_exactTable_name,
          'Newrecord': record_fields_and_value,
          'timeZone': this.timeZone,
          'formData': formData,
        };
      }

      let OldRecord = this.SelectedOldRecord;

      axios.post('/selected-table-data-manipulation-simulation', recordDetails).then(response => {
        if (formstate == 'update') {
          this.openTestModal(response.data.record_id, formData, OldRecord, formstate);
        } else {
          this.openTestModal(response.data.record_id, response.data.formData, OldRecord, formstate);
        }
      });

      this.simulationResultState = true;
      this.simulationResult = [];
    },
    executeAutomation(automation_id = null, OldRecord = null) {
      if (this.when_should == 2) {
        this.openCronModal(automation_id);
      } else if (this.when_should == 1) {
        this.saveCondition(automation_id, 'execute');
      } else if (this.when_should != 2 && this.when_should != 1) {
        this.saveCondition(automation_id, 'test_and_save');
      }

      $('#test-result-modal').modal('hide');
      this.toggleResultDiv();
    },
    setOldData(getRowDetails) {
      this.oldRecordInput = getRowDetails.name != undefined ? getRowDetails.name : getRowDetails.id;
      this.SelectedOldRecord = getRowDetails;
      let fields = this.SelectedTable.fields;
      $('.OldRecordDivIsOpen').show();

      for (let old in getRowDetails) {
        let _index = this.simulationFormData.findIndex(x => x.name == old);
        if (_index > -1) {
          if (this.simulationFormData[_index].name == 'created_by' || this.simulationFormData[_index].name == 'modified_by') {
            this.simulationFormData[_index].value = getRowDetails[old] ? getRowDetails[old] : this.SelectedTable.user_name[0].id;
          } else if (this.simulationFormData[_index].name == 'visibility') {
            this.simulationFormData[_index].value = getRowDetails[old] ? getRowDetails[old] : 1;
          } else if (old == 'multi_selection') {
            if (!getRowDetails[old]) {
              this.simulationFormData[_index].value = [];
            } else {
              this.simulationFormData[_index].value = getRowDetails[old];
            }
          } else {
            this.simulationFormData[_index].value = getRowDetails[old];
          }
        }
      }

      this.renderComponentTestModal = false;
      this.$nextTick(() => {
        this.renderComponentTestModal = true;
      });
      this.$forceUpdate();
      this.outside();
    },
    toggleDiv() {
      this.simulationFormData = [];
      this.createObjectForSimulationForm(this.SelectedTable.fields, this.simulationFormData);
      this.showTestOperationDiv = !this.showTestOperationDiv;
      this.simulationFormState = this.simulationFormState == 'created' ? 'updated' : 'created';

      this.SelectedOldRecord = [];
      this.oldRecordInput = null;
      $('#querySimulationForm')[0].reset();

      if (this.showTestOperationDiv) {
        $('.OldRecordDivIsOpen').show();
        this.mb5 = 'margin-bottom: 0px';
      } else {
        $('.OldRecordDivIsOpen').hide();
        this.mb5 = 'margin-bottom: 50px';
      }
    },
    toggleResultDiv() {
      this.showTestResultDiv = !this.showTestResultDiv;
    },
    toggleRecordResultDiv() {
      this.showTestRecordResultDiv = !this.showTestRecordResultDiv;
    },
    checkIndex(index) {
      if (index == 0) {
        return true;
      }
    },
    openCronModal(automation_id = null) {
      let _error = this.validateForm();

      if (automation_id != null) {
        // fetch cron data from db
        axios.post('/get-saved-cron_modal-data', {
          automation_id: automation_id
        }).then(response => {
          if (response.data.success) {
            // set cron maodal values
            this.cron_settings.cron_label.value = response.data.result.label;
            this.cron_settings.cron_name.value = response.data.result.name;
            this.cron_settings.cron_schedule.value = response.data.result.schedule;
            if (response.data.result.schedule == 'monthly') {
              this.daysOf = false;
            } else {
              this.daysOf = true;
            }
            this.cron_settings.cron_days_schedule.value = response.data.result.day;
            this.cron_settings.cron_execution_time.value = response.data.result.time;
            this.cron_settings.cron_execution_start_date.value = response.data.result.start_date;
            this.cron_settings.cron_execution_end_date.value = response.data.result.end_date;
          }

        });
      } else {
        this.SetCronSchedule('daily_weekly');
      }

      /*---for remove error class---*/
      this.cron_settings.cron_execution_end_date.error = false;
      if (!_error) {
        $('#cron-modal').modal('show');
      }
    },
    EditModal(id, action_id = null, data_status, level) {
      this.edit_action_entity_id = action_id;
      this.action_for_level = level;

      let _data = null;
      if (id == "#create-record-modal") {
        // if( data_status == "saved" ) {
        // 	// _data =
        // }
        // else
        if (data_status == "temp") {
          _data = this.action_details[level][action_id];
        }
        this.$refs.EditCreateActionModal.LoadDefaults(action_id, _data, data_status);
      } else if (id == "#modify-record-modal") {
        // if( data_status == "saved" ) {
        // }
        // else
        if (data_status == "temp") {
          _data = this.action_details[level][action_id];
        }
        this.$refs.EditModifyActionModal.LoadDefaults(action_id, _data, data_status);
      } else if (id == "#create-task-modal") {
        // if( data_status == "saved" ) {
        // }
        // else
        if (data_status == "temp") {
          _data = this.action_details[level][action_id];
        }
        this.$refs.EditTaskActionModal.LoadDefaults(action_id, _data, data_status);
      } else if (id == "#send-email-modal") {
        // if( data_status == "saved" ) {
        // }
        // else
        if (data_status == "temp") {
          _data = this.action_details[level][action_id];
        }
        this.$refs.EditEmailActionModal.LoadDefaults(action_id, _data, data_status);
      }
      $(id).modal('show');

      let editorElem = document.getElementsByClassName('tox-tinymce');
      for (let i = 0; i < editorElem.length; i++) {
        editorElem[i].style.height = '85%';
      }
    },
    backToprevious(sectionId) {
      this.accrodionState = sectionId;
      this.selectedOrInputValue = null;
      this.fieldConcatValue = null;
      this.check_not_empty = 0;
    },
    getInput(event) { // get custom input
      this.selectedOrInputValue = [event.target.value];
      this.check_not_empty = 1;
      this.has_value = 0;
      this.fieldConcatValue = this.table + '.' + event.target.value;
    },
    reactive() {
      this.renderComponent = false;
      this.renderComponent = true;
    },
    SetCronSchedule(schedule) {
      if (schedule == 'daily_weekly') {
        this.daysOf = true;
      } else {
        this.daysOf = false;
      }
      this.cron_settings.cron_schedule.value = schedule;
      this.cron_settings.cron_days_schedule.value = [];
    },

    //save data from cron modal
    SaveAction() {

      let input_flag = 0;

      // console.log(this.cron_settings);return;

      let __start = this.removeDynamicFormat(this.cron_settings.cron_execution_start_date.value);
      let __end = this.removeDynamicFormat(this.cron_settings.cron_execution_end_date.value);
      let __startDate = new Date(__start);
      let __endDate = new Date(__end);

      for (let cron in this.cron_settings) {

        if (!this.cron_settings[cron].value || this.cron_settings[cron].value == "") {
          this.cron_settings[cron].error = true;
          input_flag = 1;
        } else if (__startDate > __endDate) {
          this.cron_settings.cron_execution_end_date.error = true;
          input_flag = 1;
        } else {
          this.cron_settings[cron].error = false;
        }
      }

      if (input_flag == 0) {
        this.saveCondition(this.automationId);
        $('#cron-modal').modal('hide');
        // this.resetCronModal();
      }
    },
    resetCronModal() {
      // Reset all field value
      this.cron_settings.cron_label.value = null;
      this.cron_settings.cron_name.value = null;
      this.cron_settings.cron_schedule.value = null;
      this.cron_settings.cron_days_schedule.value = '';
      this.cron_settings.cron_execution_time.value = null;
      this.cron_settings.cron_execution_start_date.value = null;
      this.cron_settings.cron_execution_end_date.value = null;

    },

    removeAction(type, _id, level) {
      if (type == "saved") {
        // remove it from saved_actions
        var _index = this.saved_actions.findIndex(x => x.id == _id);

        if (_index > -1) {
          this.saved_actions.splice(_index, 1);
          this.$forceUpdate();
          // save the ids for deletion
          this.actions_to_be_removed_ids.push(_id);
        }
      } else if (type == "temp") {

        // remove it from action_details
        this.action_details[level].splice(_id, 1);
        this.$forceUpdate();
      }
    },

    GetTaskTableData() {
      axios.post('/task-table-fields').then(response => {
        if (response.data.success) {
          this.TaskTableData = response.data.data;
        }
      });
    },

    ValidateTaskInputForRequiredFields(taskData) {
      if (this.TaskTableData && this.TaskTableData.length == 0) {
        return false;
      }

      return true;
    },

    SaveActionData(_action_details) {

      console.log(_action_details);
      // create the object for saving the value
      if (this.action_details[this.action_for_level] == undefined) {
        this.action_details[this.action_for_level] = [];
      }

      // create the values based on the action details
      if (_action_details['create_record'] != undefined && _action_details['create_record']['selected_table_mapping'] != null) {
        if (this.action_for_level == _action_details['create_record'].level) {
          var _record_details = _action_details['create_record'];
          this.action_details[this.action_for_level].push({create_record: _record_details});
        }
      }

      if (_action_details['modify_record'] != undefined && _action_details['modify_record']['mapping_data'].length != 0) {
        if (this.action_for_level == _action_details['modify_record'].level) {
          var _record_details = _action_details['modify_record'];
          this.action_details[this.action_for_level].push({
            modify_record: JSON.parse(JSON.stringify(_record_details))
          });
        }
      }

      if (
          _action_details['create_task'] != undefined && this.ValidateTaskInputForRequiredFields(_action_details['create_task']['create_task'])
          && (
              _action_details['create_task']['create_task']["subject"] != null ||
              _action_details['create_task']['create_task']["start_datetime"] != null ||
              _action_details['create_task']['create_task']["end_datetime"] != null ||
              _action_details['create_task']['create_task']["category"] != null ||
              _action_details['create_task']['create_task']["status"] != null ||
              _action_details['create_task']['create_task']["assigned_to"] != null ||
              _action_details['create_task']['create_task']["priority"] != null ||
              _action_details['create_task']['create_task']["contact_name"] != null ||
              _action_details['create_task']['create_task']["person"] != null ||
              _action_details['create_task']['create_task']["long_description"] != null
          )
      ) {
        if (this.action_for_level == _action_details['create_task'].level) {
          var _task_details = _action_details['create_task'];
          this.action_details[this.action_for_level].push({create_task: _task_details});
        }
      }

      if (
          _action_details['send_email'] != undefined && (
              _action_details['send_email']['send_email']["content"] != null &&
              _action_details['send_email']['send_email']["from"] != null &&
              _action_details['send_email']['send_email']["recipient"] != null &&
              _action_details['send_email']['send_email']["subject"] != null
          )
      ) {
        if (this.action_for_level == _action_details['send_email'].level) {
          var _email_details = _action_details['send_email'];
          this.action_details[this.action_for_level].push({send_email: _email_details});
        }
      }

      this.reactive();
    },

    UpdateEmailAction(_action_details) {
      if (
          _action_details['send_email'] != undefined && (
              _action_details['send_email']['send_email']["content"] != null ||
              _action_details['send_email']['send_email']["from"] != null ||
              _action_details['send_email']['send_email']["recipient"] != null ||
              _action_details['send_email']['send_email']["cc"] != null ||
              _action_details['send_email']['send_email']["subject"] != null
          )
      ) {
        var _email_details = _action_details['send_email'];
        if (_action_details.action_id != null) {

          // update the saved values
          var _index = this.saved_actions.findIndex(x => x.id == _action_details.action_id);
          if (_index > -1) {
            var entity = this.saved_actions[_index];

            this.$set(entity, 'action_map', _email_details);
            this.$set(this.saved_actions, _index, entity);
            this.fireActionAutosaveXHR(entity);
          }
        } else {
          this.$set(this.action_details[_action_details.send_email.level], this.edit_action_entity_id, {send_email: _email_details});
        }
      }

      this.$forceUpdate();
    },

    UpdateTaskAction(_action_details) {
      if (
          _action_details['create_task'] != undefined && this.ValidateTaskInputForRequiredFields(_action_details['create_task']['create_task'])
          // (
          // 	_action_details['create_task']['create_task']["category"] != null ||
          // 	_action_details['create_task']['create_task']["description"] != null ||
          // 	_action_details['create_task']['create_task']["due_date"] != null ||
          // 	_action_details['create_task']['create_task']["related_to"] != null ||
          // 	_action_details['create_task']['create_task']["task"] != null ||
          // 	_action_details['create_task']['create_task']["responsible"] != null
          // )
      ) {
        var _task_details = _action_details['create_task'];

        if (_action_details.action_id != null) {
          // update the saved values
          var _index = this.saved_actions.findIndex(x => x.id == _action_details.action_id);
          if (_index > -1) {
            var entity = this.saved_actions[_index];

            this.$set(entity, 'action_map', _task_details);
            this.$set(this.saved_actions, _index, entity);
            this.fireActionAutosaveXHR(entity);
          }
        } else {
          this.$set(this.action_details[_action_details.create_task.level], this.edit_action_entity_id, {create_task: _task_details});
        }
      }
    },

    UpdateCreateRecordAction(_action_details) {
      if (_action_details['create_record'] != undefined) {
        var _create_record_details = _action_details['create_record'];

        if (_action_details.action_id != null) {
          // update the saved values
          var _index = this.saved_actions.findIndex(x => x.id == _action_details.action_id);

          if (_index > -1) {
            var entity = this.saved_actions[_index];

            /*this.$set(entity, 'action_map', _create_record_details);
					this.$set(this.saved_actions, _index, entity);
					this.fireActionAutosaveXHR(entity);*/

            this.$set(entity, 'action_map', _create_record_details);

            axios.post('/set-saved-action-data', {
              saved_actions: entity,
              timeZone: this.timeZone,
            }).then(response => {
              const upadated_entity = response.data;
              this.$set(this.saved_actions, _index, upadated_entity);
            });
          }
        } else {
          this.$set(this.action_details[_action_details.create_record.level], this.edit_action_entity_id, {create_record: _create_record_details});
        }
      }
    },
    UpdateModifyRecordAction(_action_details) {

      if (_action_details['modify_record'] != undefined) {
        var _modify_record_details = _action_details['modify_record'];

        if (_action_details.action_id != null) {
          // update the saved values
          var _index = this.saved_actions.findIndex(x => x.id == _action_details.action_id);

          if (_index > -1) {
            var entity = this.saved_actions[_index];

            /*this.$set(entity, 'action_map', _modify_record_details);
					this.$set(this.saved_actions, _index, entity);
					this.fireActionAutosaveXHR(entity);*/


            this.$set(entity, 'action_map', _modify_record_details);

            axios.post('/set-saved-action-data', {
              saved_actions: entity,
              timeZone: this.timeZone,
            }).then(response => {
              const upadated_entity = response.data;
              this.$set(this.saved_actions, _index, upadated_entity);
            });
          }
        } else {
          this.$set(this.action_details[_action_details.modify_record.level], this.edit_action_entity_id, {modify_record: JSON.parse(JSON.stringify(_modify_record_details))});
        }
      }
    },
    fireActionAutosaveXHR(savedActions) {
      axios.post('/set-saved-action-data', {
        saved_actions: savedActions,
        timeZone: this.timeZone,
      });
    },
    /** This is a toggle function */
    SelectCronTiming(value) {
      var _index = this.cron_settings.cron_days_schedule.value.indexOf(value);
      if (_index > -1) {
        this.cron_settings.cron_days_schedule.value.splice(_index, 1);
      } else {
        this.cron_settings.cron_days_schedule.value.push(value);
      }
    },
    CheckCronTimingSelected(value) {
      // if value exists in the array return true
      var _index = this.cron_settings.cron_days_schedule.value.indexOf(value);
      if (_index > -1) {
        return true;
      } else {
        return false;
      }
    },
    setDynamicFormat() {
      switch (this.auth.formatting.date_order) {
        case 'd-m-Y':
          return this.setDateSeparator('DD-MM-YYYY');
          break;
        case 'm-d-Y':
          return this.setDateSeparator('MM-DD-YYYY');
          break;
        case 'Y-m-d' :
          return this.setDateSeparator('YYYY-MM-DD');
          break;
        case 'Y-d-m' :
          return this.setDateSeparator('YYYY-DD-MM');
          break;
        default :
          return this.setDateSeparator('DD-MM-YYYY');
      }
    },
    setDateSeparator(format) {
      if (this.auth.formatting.date_separator) {
        let _separator = this.auth.formatting.date_separator;
        return format.replace(/-/g, _separator);
      } else {
        return format;
      }
    },
    contentTemplate(_email) {
      this.emailContentHtml = _email.content;
      $('#email-content-modal').modal('show');
    },
    removeDynamicFormat(value) {
      let _separator = this.auth.formatting.date_separator;
      let parts = value.split(_separator);
      switch (this.auth.formatting.date_order) {
        case 'd-m-Y':
          return parts[2] + '-' + parts[1] + '-' + parts[0];
          break;
        case 'm-d-Y':
          return parts[2] + '-' + parts[0] + '-' + parts[1];
          break;
        case 'Y-m-d' :
          return parts[0] + '-' + parts[1] + '-' + parts[2];
          break;
        case 'Y-d-m' :
          return parts[0] + '-' + parts[2] + '-' + parts[1];
          break;
        default :
          return parts[2] + '-' + parts[1] + '-' + parts[0];
      }
    },
  }
}
</script>
